/******/ (function(modules) { // webpackBootstrap
/******/ 	var parentHotUpdateCallback = this["webpackHotUpdate"];
/******/ 	this["webpackHotUpdate"] = function webpackHotUpdateCallback(chunkId, moreModules) { // eslint-disable-line no-unused-vars
/******/ 		hotAddUpdateChunk(chunkId, moreModules);
/******/ 		if(parentHotUpdateCallback) parentHotUpdateCallback(chunkId, moreModules);
/******/ 	}
/******/
/******/ 	function hotDownloadUpdateChunk(chunkId) { // eslint-disable-line no-unused-vars
/******/ 		var head = document.getElementsByTagName("head")[0];
/******/ 		var script = document.createElement("script");
/******/ 		script.type = "text/javascript";
/******/ 		script.charset = "utf-8";
/******/ 		script.src = __webpack_require__.p + "" + chunkId + "." + hotCurrentHash + ".hot-update.js";
/******/ 		head.appendChild(script);
/******/ 	}
/******/
/******/ 	function hotDownloadManifest(callback) { // eslint-disable-line no-unused-vars
/******/ 		if(typeof XMLHttpRequest === "undefined")
/******/ 			return callback(new Error("No browser support"));
/******/ 		try {
/******/ 			var request = new XMLHttpRequest();
/******/ 			var requestPath = __webpack_require__.p + "" + hotCurrentHash + ".hot-update.json";
/******/ 			request.open("GET", requestPath, true);
/******/ 			request.timeout = 10000;
/******/ 			request.send(null);
/******/ 		} catch(err) {
/******/ 			return callback(err);
/******/ 		}
/******/ 		request.onreadystatechange = function() {
/******/ 			if(request.readyState !== 4) return;
/******/ 			if(request.status === 0) {
/******/ 				// timeout
/******/ 				callback(new Error("Manifest request to " + requestPath + " timed out."));
/******/ 			} else if(request.status === 404) {
/******/ 				// no update available
/******/ 				callback();
/******/ 			} else if(request.status !== 200 && request.status !== 304) {
/******/ 				// other failure
/******/ 				callback(new Error("Manifest request to " + requestPath + " failed."));
/******/ 			} else {
/******/ 				// success
/******/ 				try {
/******/ 					var update = JSON.parse(request.responseText);
/******/ 				} catch(e) {
/******/ 					callback(e);
/******/ 					return;
/******/ 				}
/******/ 				callback(null, update);
/******/ 			}
/******/ 		};
/******/ 	}
/******/
/******/
/******/ 	// Copied from https://github.com/facebook/react/blob/bef45b0/src/shared/utils/canDefineProperty.js
/******/ 	var canDefineProperty = false;
/******/ 	try {
/******/ 		Object.defineProperty({}, "x", {
/******/ 			get: function() {}
/******/ 		});
/******/ 		canDefineProperty = true;
/******/ 	} catch(x) {
/******/ 		// IE will fail on defineProperty
/******/ 	}
/******/
/******/ 	var hotApplyOnUpdate = true;
/******/ 	var hotCurrentHash = "90419a3134a9060be94b"; // eslint-disable-line no-unused-vars
/******/ 	var hotCurrentModuleData = {};
/******/ 	var hotCurrentParents = []; // eslint-disable-line no-unused-vars
/******/
/******/ 	function hotCreateRequire(moduleId) { // eslint-disable-line no-unused-vars
/******/ 		var me = installedModules[moduleId];
/******/ 		if(!me) return __webpack_require__;
/******/ 		var fn = function(request) {
/******/ 			if(me.hot.active) {
/******/ 				if(installedModules[request]) {
/******/ 					if(installedModules[request].parents.indexOf(moduleId) < 0)
/******/ 						installedModules[request].parents.push(moduleId);
/******/ 					if(me.children.indexOf(request) < 0)
/******/ 						me.children.push(request);
/******/ 				} else hotCurrentParents = [moduleId];
/******/ 			} else {
/******/ 				console.warn("[HMR] unexpected require(" + request + ") from disposed module " + moduleId);
/******/ 				hotCurrentParents = [];
/******/ 			}
/******/ 			return __webpack_require__(request);
/******/ 		};
/******/ 		for(var name in __webpack_require__) {
/******/ 			if(Object.prototype.hasOwnProperty.call(__webpack_require__, name)) {
/******/ 				if(canDefineProperty) {
/******/ 					Object.defineProperty(fn, name, (function(name) {
/******/ 						return {
/******/ 							configurable: true,
/******/ 							enumerable: true,
/******/ 							get: function() {
/******/ 								return __webpack_require__[name];
/******/ 							},
/******/ 							set: function(value) {
/******/ 								__webpack_require__[name] = value;
/******/ 							}
/******/ 						};
/******/ 					}(name)));
/******/ 				} else {
/******/ 					fn[name] = __webpack_require__[name];
/******/ 				}
/******/ 			}
/******/ 		}
/******/
/******/ 		function ensure(chunkId, callback) {
/******/ 			if(hotStatus === "ready")
/******/ 				hotSetStatus("prepare");
/******/ 			hotChunksLoading++;
/******/ 			__webpack_require__.e(chunkId, function() {
/******/ 				try {
/******/ 					callback.call(null, fn);
/******/ 				} finally {
/******/ 					finishChunkLoading();
/******/ 				}
/******/
/******/ 				function finishChunkLoading() {
/******/ 					hotChunksLoading--;
/******/ 					if(hotStatus === "prepare") {
/******/ 						if(!hotWaitingFilesMap[chunkId]) {
/******/ 							hotEnsureUpdateChunk(chunkId);
/******/ 						}
/******/ 						if(hotChunksLoading === 0 && hotWaitingFiles === 0) {
/******/ 							hotUpdateDownloaded();
/******/ 						}
/******/ 					}
/******/ 				}
/******/ 			});
/******/ 		}
/******/ 		if(canDefineProperty) {
/******/ 			Object.defineProperty(fn, "e", {
/******/ 				enumerable: true,
/******/ 				value: ensure
/******/ 			});
/******/ 		} else {
/******/ 			fn.e = ensure;
/******/ 		}
/******/ 		return fn;
/******/ 	}
/******/
/******/ 	function hotCreateModule(moduleId) { // eslint-disable-line no-unused-vars
/******/ 		var hot = {
/******/ 			// private stuff
/******/ 			_acceptedDependencies: {},
/******/ 			_declinedDependencies: {},
/******/ 			_selfAccepted: false,
/******/ 			_selfDeclined: false,
/******/ 			_disposeHandlers: [],
/******/
/******/ 			// Module API
/******/ 			active: true,
/******/ 			accept: function(dep, callback) {
/******/ 				if(typeof dep === "undefined")
/******/ 					hot._selfAccepted = true;
/******/ 				else if(typeof dep === "function")
/******/ 					hot._selfAccepted = dep;
/******/ 				else if(typeof dep === "object")
/******/ 					for(var i = 0; i < dep.length; i++)
/******/ 						hot._acceptedDependencies[dep[i]] = callback;
/******/ 				else
/******/ 					hot._acceptedDependencies[dep] = callback;
/******/ 			},
/******/ 			decline: function(dep) {
/******/ 				if(typeof dep === "undefined")
/******/ 					hot._selfDeclined = true;
/******/ 				else if(typeof dep === "number")
/******/ 					hot._declinedDependencies[dep] = true;
/******/ 				else
/******/ 					for(var i = 0; i < dep.length; i++)
/******/ 						hot._declinedDependencies[dep[i]] = true;
/******/ 			},
/******/ 			dispose: function(callback) {
/******/ 				hot._disposeHandlers.push(callback);
/******/ 			},
/******/ 			addDisposeHandler: function(callback) {
/******/ 				hot._disposeHandlers.push(callback);
/******/ 			},
/******/ 			removeDisposeHandler: function(callback) {
/******/ 				var idx = hot._disposeHandlers.indexOf(callback);
/******/ 				if(idx >= 0) hot._disposeHandlers.splice(idx, 1);
/******/ 			},
/******/
/******/ 			// Management API
/******/ 			check: hotCheck,
/******/ 			apply: hotApply,
/******/ 			status: function(l) {
/******/ 				if(!l) return hotStatus;
/******/ 				hotStatusHandlers.push(l);
/******/ 			},
/******/ 			addStatusHandler: function(l) {
/******/ 				hotStatusHandlers.push(l);
/******/ 			},
/******/ 			removeStatusHandler: function(l) {
/******/ 				var idx = hotStatusHandlers.indexOf(l);
/******/ 				if(idx >= 0) hotStatusHandlers.splice(idx, 1);
/******/ 			},
/******/
/******/ 			//inherit from previous dispose call
/******/ 			data: hotCurrentModuleData[moduleId]
/******/ 		};
/******/ 		return hot;
/******/ 	}
/******/
/******/ 	var hotStatusHandlers = [];
/******/ 	var hotStatus = "idle";
/******/
/******/ 	function hotSetStatus(newStatus) {
/******/ 		hotStatus = newStatus;
/******/ 		for(var i = 0; i < hotStatusHandlers.length; i++)
/******/ 			hotStatusHandlers[i].call(null, newStatus);
/******/ 	}
/******/
/******/ 	// while downloading
/******/ 	var hotWaitingFiles = 0;
/******/ 	var hotChunksLoading = 0;
/******/ 	var hotWaitingFilesMap = {};
/******/ 	var hotRequestedFilesMap = {};
/******/ 	var hotAvailibleFilesMap = {};
/******/ 	var hotCallback;
/******/
/******/ 	// The update info
/******/ 	var hotUpdate, hotUpdateNewHash;
/******/
/******/ 	function toModuleId(id) {
/******/ 		var isNumber = (+id) + "" === id;
/******/ 		return isNumber ? +id : id;
/******/ 	}
/******/
/******/ 	function hotCheck(apply, callback) {
/******/ 		if(hotStatus !== "idle") throw new Error("check() is only allowed in idle status");
/******/ 		if(typeof apply === "function") {
/******/ 			hotApplyOnUpdate = false;
/******/ 			callback = apply;
/******/ 		} else {
/******/ 			hotApplyOnUpdate = apply;
/******/ 			callback = callback || function(err) {
/******/ 				if(err) throw err;
/******/ 			};
/******/ 		}
/******/ 		hotSetStatus("check");
/******/ 		hotDownloadManifest(function(err, update) {
/******/ 			if(err) return callback(err);
/******/ 			if(!update) {
/******/ 				hotSetStatus("idle");
/******/ 				callback(null, null);
/******/ 				return;
/******/ 			}
/******/
/******/ 			hotRequestedFilesMap = {};
/******/ 			hotAvailibleFilesMap = {};
/******/ 			hotWaitingFilesMap = {};
/******/ 			for(var i = 0; i < update.c.length; i++)
/******/ 				hotAvailibleFilesMap[update.c[i]] = true;
/******/ 			hotUpdateNewHash = update.h;
/******/
/******/ 			hotSetStatus("prepare");
/******/ 			hotCallback = callback;
/******/ 			hotUpdate = {};
/******/ 			var chunkId = 1;
/******/ 			{ // eslint-disable-line no-lone-blocks
/******/ 				/*globals chunkId */
/******/ 				hotEnsureUpdateChunk(chunkId);
/******/ 			}
/******/ 			if(hotStatus === "prepare" && hotChunksLoading === 0 && hotWaitingFiles === 0) {
/******/ 				hotUpdateDownloaded();
/******/ 			}
/******/ 		});
/******/ 	}
/******/
/******/ 	function hotAddUpdateChunk(chunkId, moreModules) { // eslint-disable-line no-unused-vars
/******/ 		if(!hotAvailibleFilesMap[chunkId] || !hotRequestedFilesMap[chunkId])
/******/ 			return;
/******/ 		hotRequestedFilesMap[chunkId] = false;
/******/ 		for(var moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				hotUpdate[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(--hotWaitingFiles === 0 && hotChunksLoading === 0) {
/******/ 			hotUpdateDownloaded();
/******/ 		}
/******/ 	}
/******/
/******/ 	function hotEnsureUpdateChunk(chunkId) {
/******/ 		if(!hotAvailibleFilesMap[chunkId]) {
/******/ 			hotWaitingFilesMap[chunkId] = true;
/******/ 		} else {
/******/ 			hotRequestedFilesMap[chunkId] = true;
/******/ 			hotWaitingFiles++;
/******/ 			hotDownloadUpdateChunk(chunkId);
/******/ 		}
/******/ 	}
/******/
/******/ 	function hotUpdateDownloaded() {
/******/ 		hotSetStatus("ready");
/******/ 		var callback = hotCallback;
/******/ 		hotCallback = null;
/******/ 		if(!callback) return;
/******/ 		if(hotApplyOnUpdate) {
/******/ 			hotApply(hotApplyOnUpdate, callback);
/******/ 		} else {
/******/ 			var outdatedModules = [];
/******/ 			for(var id in hotUpdate) {
/******/ 				if(Object.prototype.hasOwnProperty.call(hotUpdate, id)) {
/******/ 					outdatedModules.push(toModuleId(id));
/******/ 				}
/******/ 			}
/******/ 			callback(null, outdatedModules);
/******/ 		}
/******/ 	}
/******/
/******/ 	function hotApply(options, callback) {
/******/ 		if(hotStatus !== "ready") throw new Error("apply() is only allowed in ready status");
/******/ 		if(typeof options === "function") {
/******/ 			callback = options;
/******/ 			options = {};
/******/ 		} else if(options && typeof options === "object") {
/******/ 			callback = callback || function(err) {
/******/ 				if(err) throw err;
/******/ 			};
/******/ 		} else {
/******/ 			options = {};
/******/ 			callback = callback || function(err) {
/******/ 				if(err) throw err;
/******/ 			};
/******/ 		}
/******/
/******/ 		function getAffectedStuff(module) {
/******/ 			var outdatedModules = [module];
/******/ 			var outdatedDependencies = {};
/******/
/******/ 			var queue = outdatedModules.slice();
/******/ 			while(queue.length > 0) {
/******/ 				var moduleId = queue.pop();
/******/ 				var module = installedModules[moduleId];
/******/ 				if(!module || module.hot._selfAccepted)
/******/ 					continue;
/******/ 				if(module.hot._selfDeclined) {
/******/ 					return new Error("Aborted because of self decline: " + moduleId);
/******/ 				}
/******/ 				if(moduleId === 0) {
/******/ 					return;
/******/ 				}
/******/ 				for(var i = 0; i < module.parents.length; i++) {
/******/ 					var parentId = module.parents[i];
/******/ 					var parent = installedModules[parentId];
/******/ 					if(parent.hot._declinedDependencies[moduleId]) {
/******/ 						return new Error("Aborted because of declined dependency: " + moduleId + " in " + parentId);
/******/ 					}
/******/ 					if(outdatedModules.indexOf(parentId) >= 0) continue;
/******/ 					if(parent.hot._acceptedDependencies[moduleId]) {
/******/ 						if(!outdatedDependencies[parentId])
/******/ 							outdatedDependencies[parentId] = [];
/******/ 						addAllToSet(outdatedDependencies[parentId], [moduleId]);
/******/ 						continue;
/******/ 					}
/******/ 					delete outdatedDependencies[parentId];
/******/ 					outdatedModules.push(parentId);
/******/ 					queue.push(parentId);
/******/ 				}
/******/ 			}
/******/
/******/ 			return [outdatedModules, outdatedDependencies];
/******/ 		}
/******/
/******/ 		function addAllToSet(a, b) {
/******/ 			for(var i = 0; i < b.length; i++) {
/******/ 				var item = b[i];
/******/ 				if(a.indexOf(item) < 0)
/******/ 					a.push(item);
/******/ 			}
/******/ 		}
/******/
/******/ 		// at begin all updates modules are outdated
/******/ 		// the "outdated" status can propagate to parents if they don't accept the children
/******/ 		var outdatedDependencies = {};
/******/ 		var outdatedModules = [];
/******/ 		var appliedUpdate = {};
/******/ 		for(var id in hotUpdate) {
/******/ 			if(Object.prototype.hasOwnProperty.call(hotUpdate, id)) {
/******/ 				var moduleId = toModuleId(id);
/******/ 				var result = getAffectedStuff(moduleId);
/******/ 				if(!result) {
/******/ 					if(options.ignoreUnaccepted)
/******/ 						continue;
/******/ 					hotSetStatus("abort");
/******/ 					return callback(new Error("Aborted because " + moduleId + " is not accepted"));
/******/ 				}
/******/ 				if(result instanceof Error) {
/******/ 					hotSetStatus("abort");
/******/ 					return callback(result);
/******/ 				}
/******/ 				appliedUpdate[moduleId] = hotUpdate[moduleId];
/******/ 				addAllToSet(outdatedModules, result[0]);
/******/ 				for(var moduleId in result[1]) {
/******/ 					if(Object.prototype.hasOwnProperty.call(result[1], moduleId)) {
/******/ 						if(!outdatedDependencies[moduleId])
/******/ 							outdatedDependencies[moduleId] = [];
/******/ 						addAllToSet(outdatedDependencies[moduleId], result[1][moduleId]);
/******/ 					}
/******/ 				}
/******/ 			}
/******/ 		}
/******/
/******/ 		// Store self accepted outdated modules to require them later by the module system
/******/ 		var outdatedSelfAcceptedModules = [];
/******/ 		for(var i = 0; i < outdatedModules.length; i++) {
/******/ 			var moduleId = outdatedModules[i];
/******/ 			if(installedModules[moduleId] && installedModules[moduleId].hot._selfAccepted)
/******/ 				outdatedSelfAcceptedModules.push({
/******/ 					module: moduleId,
/******/ 					errorHandler: installedModules[moduleId].hot._selfAccepted
/******/ 				});
/******/ 		}
/******/
/******/ 		// Now in "dispose" phase
/******/ 		hotSetStatus("dispose");
/******/ 		var queue = outdatedModules.slice();
/******/ 		while(queue.length > 0) {
/******/ 			var moduleId = queue.pop();
/******/ 			var module = installedModules[moduleId];
/******/ 			if(!module) continue;
/******/
/******/ 			var data = {};
/******/
/******/ 			// Call dispose handlers
/******/ 			var disposeHandlers = module.hot._disposeHandlers;
/******/ 			for(var j = 0; j < disposeHandlers.length; j++) {
/******/ 				var cb = disposeHandlers[j];
/******/ 				cb(data);
/******/ 			}
/******/ 			hotCurrentModuleData[moduleId] = data;
/******/
/******/ 			// disable module (this disables requires from this module)
/******/ 			module.hot.active = false;
/******/
/******/ 			// remove module from cache
/******/ 			delete installedModules[moduleId];
/******/
/******/ 			// remove "parents" references from all children
/******/ 			for(var j = 0; j < module.children.length; j++) {
/******/ 				var child = installedModules[module.children[j]];
/******/ 				if(!child) continue;
/******/ 				var idx = child.parents.indexOf(moduleId);
/******/ 				if(idx >= 0) {
/******/ 					child.parents.splice(idx, 1);
/******/ 				}
/******/ 			}
/******/ 		}
/******/
/******/ 		// remove outdated dependency from module children
/******/ 		for(var moduleId in outdatedDependencies) {
/******/ 			if(Object.prototype.hasOwnProperty.call(outdatedDependencies, moduleId)) {
/******/ 				var module = installedModules[moduleId];
/******/ 				var moduleOutdatedDependencies = outdatedDependencies[moduleId];
/******/ 				for(var j = 0; j < moduleOutdatedDependencies.length; j++) {
/******/ 					var dependency = moduleOutdatedDependencies[j];
/******/ 					var idx = module.children.indexOf(dependency);
/******/ 					if(idx >= 0) module.children.splice(idx, 1);
/******/ 				}
/******/ 			}
/******/ 		}
/******/
/******/ 		// Not in "apply" phase
/******/ 		hotSetStatus("apply");
/******/
/******/ 		hotCurrentHash = hotUpdateNewHash;
/******/
/******/ 		// insert new code
/******/ 		for(var moduleId in appliedUpdate) {
/******/ 			if(Object.prototype.hasOwnProperty.call(appliedUpdate, moduleId)) {
/******/ 				modules[moduleId] = appliedUpdate[moduleId];
/******/ 			}
/******/ 		}
/******/
/******/ 		// call accept handlers
/******/ 		var error = null;
/******/ 		for(var moduleId in outdatedDependencies) {
/******/ 			if(Object.prototype.hasOwnProperty.call(outdatedDependencies, moduleId)) {
/******/ 				var module = installedModules[moduleId];
/******/ 				var moduleOutdatedDependencies = outdatedDependencies[moduleId];
/******/ 				var callbacks = [];
/******/ 				for(var i = 0; i < moduleOutdatedDependencies.length; i++) {
/******/ 					var dependency = moduleOutdatedDependencies[i];
/******/ 					var cb = module.hot._acceptedDependencies[dependency];
/******/ 					if(callbacks.indexOf(cb) >= 0) continue;
/******/ 					callbacks.push(cb);
/******/ 				}
/******/ 				for(var i = 0; i < callbacks.length; i++) {
/******/ 					var cb = callbacks[i];
/******/ 					try {
/******/ 						cb(outdatedDependencies);
/******/ 					} catch(err) {
/******/ 						if(!error)
/******/ 							error = err;
/******/ 					}
/******/ 				}
/******/ 			}
/******/ 		}
/******/
/******/ 		// Load self accepted modules
/******/ 		for(var i = 0; i < outdatedSelfAcceptedModules.length; i++) {
/******/ 			var item = outdatedSelfAcceptedModules[i];
/******/ 			var moduleId = item.module;
/******/ 			hotCurrentParents = [moduleId];
/******/ 			try {
/******/ 				__webpack_require__(moduleId);
/******/ 			} catch(err) {
/******/ 				if(typeof item.errorHandler === "function") {
/******/ 					try {
/******/ 						item.errorHandler(err);
/******/ 					} catch(err) {
/******/ 						if(!error)
/******/ 							error = err;
/******/ 					}
/******/ 				} else if(!error)
/******/ 					error = err;
/******/ 			}
/******/ 		}
/******/
/******/ 		// handle errors in accept handlers and self accepted module load
/******/ 		if(error) {
/******/ 			hotSetStatus("fail");
/******/ 			return callback(error);
/******/ 		}
/******/
/******/ 		hotSetStatus("idle");
/******/ 		callback(null, outdatedModules);
/******/ 	}
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			hot: hotCreateModule(moduleId),
/******/ 			parents: hotCurrentParents,
/******/ 			children: []
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, hotCreateRequire(moduleId));
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// __webpack_hash__
/******/ 	__webpack_require__.h = function() { return hotCurrentHash; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return hotCreateRequire(0)(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	var index = __webpack_require__(26),
	    banner = __webpack_require__(29);
	//define('index',function(){
	//	$("#weixin").on('tap',function(){
	//		$("#airwheel_weixin").show();
	//		$("#airwheel_weixin .weixin").addClass("prompt_show");
	//	});
	//});
	//define(['index'],function(index){})
	//$(function() {
	//	$("#weixin").on('tap', function() {
	//		$("#airwheel_weixin").show();
	//		$("#airwheel_weixin .weixin").addClass("prompt_show");
	//	});
	//	$("#airwheel_weixin").on('tap', function() {
	//		$("#airwheel_weixin").hide();
	//		$("#airwheel_weixin .weixin").removeClass("prompt_show");
	//	});
	//})

/***/ },
/* 1 */,
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* Zepto v1.2.0 - zepto event ajax form ie - zeptojs.com/license */
	(function (global, factory) {
	    if (exports === 'object' && typeof module !== 'undefined') module.exports = factory(global);
	    if (true) !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	        return factory(global);
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else factory(global);
	})(typeof window !== "undefined" ? window : this, function (window) {
	    var Zepto = function () {
	        var undefined,
	            key,
	            $,
	            classList,
	            emptyArray = [],
	            concat = emptyArray.concat,
	            filter = emptyArray.filter,
	            slice = emptyArray.slice,
	            document = window.document,
	            elementDisplay = {},
	            classCache = {},
	            cssNumber = { 'column-count': 1, 'columns': 1, 'font-weight': 1, 'line-height': 1, 'opacity': 1, 'z-index': 1, 'zoom': 1 },
	            fragmentRE = /^\s*<(\w+|!)[^>]*>/,
	            singleTagRE = /^<(\w+)\s*\/?>(?:<\/\1>|)$/,
	            tagExpanderRE = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/ig,
	            rootNodeRE = /^(?:body|html)$/i,
	            capitalRE = /([A-Z])/g,
	
	
	        // special attributes that should be get/set via method calls
	        methodAttributes = ['val', 'css', 'html', 'text', 'data', 'width', 'height', 'offset'],
	            adjacencyOperators = ['after', 'prepend', 'before', 'append'],
	            table = document.createElement('table'),
	            tableRow = document.createElement('tr'),
	            containers = {
	            'tr': document.createElement('tbody'),
	            'tbody': table, 'thead': table, 'tfoot': table,
	            'td': tableRow, 'th': tableRow,
	            '*': document.createElement('div')
	        },
	            readyRE = /complete|loaded|interactive/,
	            simpleSelectorRE = /^[\w-]*$/,
	            class2type = {},
	            toString = class2type.toString,
	            zepto = {},
	            camelize,
	            uniq,
	            tempParent = document.createElement('div'),
	            propMap = {
	            'tabindex': 'tabIndex',
	            'readonly': 'readOnly',
	            'for': 'htmlFor',
	            'class': 'className',
	            'maxlength': 'maxLength',
	            'cellspacing': 'cellSpacing',
	            'cellpadding': 'cellPadding',
	            'rowspan': 'rowSpan',
	            'colspan': 'colSpan',
	            'usemap': 'useMap',
	            'frameborder': 'frameBorder',
	            'contenteditable': 'contentEditable'
	        },
	            isArray = Array.isArray || function (object) {
	            return object instanceof Array;
	        };
	
	        zepto.matches = function (element, selector) {
	            if (!selector || !element || element.nodeType !== 1) return false;
	            var matchesSelector = element.matches || element.webkitMatchesSelector || element.mozMatchesSelector || element.oMatchesSelector || element.matchesSelector;
	            if (matchesSelector) return matchesSelector.call(element, selector);
	            // fall back to performing a selector:
	            var match,
	                parent = element.parentNode,
	                temp = !parent;
	            if (temp) (parent = tempParent).appendChild(element);
	            match = ~zepto.qsa(parent, selector).indexOf(element);
	            temp && tempParent.removeChild(element);
	            return match;
	        };
	
	        function type(obj) {
	            return obj == null ? String(obj) : class2type[toString.call(obj)] || "object";
	        }
	
	        function isFunction(value) {
	            return type(value) == "function";
	        }
	        function isWindow(obj) {
	            return obj != null && obj == obj.window;
	        }
	        function isDocument(obj) {
	            return obj != null && obj.nodeType == obj.DOCUMENT_NODE;
	        }
	        function isObject(obj) {
	            return type(obj) == "object";
	        }
	        function isPlainObject(obj) {
	            return isObject(obj) && !isWindow(obj) && Object.getPrototypeOf(obj) == Object.prototype;
	        }
	
	        function likeArray(obj) {
	            var length = !!obj && 'length' in obj && obj.length,
	                type = $.type(obj);
	
	            return 'function' != type && !isWindow(obj) && ('array' == type || length === 0 || typeof length == 'number' && length > 0 && length - 1 in obj);
	        }
	
	        function compact(array) {
	            return filter.call(array, function (item) {
	                return item != null;
	            });
	        }
	        function flatten(array) {
	            return array.length > 0 ? $.fn.concat.apply([], array) : array;
	        }
	        camelize = function (str) {
	            return str.replace(/-+(.)?/g, function (match, chr) {
	                return chr ? chr.toUpperCase() : '';
	            });
	        };
	        function dasherize(str) {
	            return str.replace(/::/g, '/').replace(/([A-Z]+)([A-Z][a-z])/g, '$1_$2').replace(/([a-z\d])([A-Z])/g, '$1_$2').replace(/_/g, '-').toLowerCase();
	        }
	        uniq = function (array) {
	            return filter.call(array, function (item, idx) {
	                return array.indexOf(item) == idx;
	            });
	        };
	
	        function classRE(name) {
	            return name in classCache ? classCache[name] : classCache[name] = new RegExp('(^|\\s)' + name + '(\\s|$)');
	        }
	
	        function maybeAddPx(name, value) {
	            return typeof value == "number" && !cssNumber[dasherize(name)] ? value + "px" : value;
	        }
	
	        function defaultDisplay(nodeName) {
	            var element, display;
	            if (!elementDisplay[nodeName]) {
	                element = document.createElement(nodeName);
	                document.body.appendChild(element);
	                display = getComputedStyle(element, '').getPropertyValue("display");
	                element.parentNode.removeChild(element);
	                display == "none" && (display = "block");
	                elementDisplay[nodeName] = display;
	            }
	            return elementDisplay[nodeName];
	        }
	
	        function children(element) {
	            return 'children' in element ? slice.call(element.children) : $.map(element.childNodes, function (node) {
	                if (node.nodeType == 1) return node;
	            });
	        }
	
	        function Z(dom, selector) {
	            var i,
	                len = dom ? dom.length : 0;
	            for (i = 0; i < len; i++) this[i] = dom[i];
	            this.length = len;
	            this.selector = selector || '';
	        }
	
	        // `$.zepto.fragment` takes a html string and an optional tag name
	        // to generate DOM nodes from the given html string.
	        // The generated DOM nodes are returned as an array.
	        // This function can be overridden in plugins for example to make
	        // it compatible with browsers that don't support the DOM fully.
	        zepto.fragment = function (html, name, properties) {
	            var dom, nodes, container;
	
	            // A special case optimization for a single tag
	            if (singleTagRE.test(html)) dom = $(document.createElement(RegExp.$1));
	
	            if (!dom) {
	                if (html.replace) html = html.replace(tagExpanderRE, "<$1></$2>");
	                if (name === undefined) name = fragmentRE.test(html) && RegExp.$1;
	                if (!(name in containers)) name = '*';
	
	                container = containers[name];
	                container.innerHTML = '' + html;
	                dom = $.each(slice.call(container.childNodes), function () {
	                    container.removeChild(this);
	                });
	            }
	
	            if (isPlainObject(properties)) {
	                nodes = $(dom);
	                $.each(properties, function (key, value) {
	                    if (methodAttributes.indexOf(key) > -1) nodes[key](value);else nodes.attr(key, value);
	                });
	            }
	
	            return dom;
	        };
	
	        // `$.zepto.Z` swaps out the prototype of the given `dom` array
	        // of nodes with `$.fn` and thus supplying all the Zepto functions
	        // to the array. This method can be overridden in plugins.
	        zepto.Z = function (dom, selector) {
	            return new Z(dom, selector);
	        };
	
	        // `$.zepto.isZ` should return `true` if the given object is a Zepto
	        // collection. This method can be overridden in plugins.
	        zepto.isZ = function (object) {
	            return object instanceof zepto.Z;
	        };
	
	        // `$.zepto.init` is Zepto's counterpart to jQuery's `$.fn.init` and
	        // takes a CSS selector and an optional context (and handles various
	        // special cases).
	        // This method can be overridden in plugins.
	        zepto.init = function (selector, context) {
	            var dom;
	            // If nothing given, return an empty Zepto collection
	            if (!selector) return zepto.Z();
	            // Optimize for string selectors
	            else if (typeof selector == 'string') {
	                    selector = selector.trim();
	                    // If it's a html fragment, create nodes from it
	                    // Note: In both Chrome 21 and Firefox 15, DOM error 12
	                    // is thrown if the fragment doesn't begin with <
	                    if (selector[0] == '<' && fragmentRE.test(selector)) dom = zepto.fragment(selector, RegExp.$1, context), selector = null;
	                    // If there's a context, create a collection on that context first, and select
	                    // nodes from there
	                    else if (context !== undefined) return $(context).find(selector);
	                        // If it's a CSS selector, use it to select nodes.
	                        else dom = zepto.qsa(document, selector);
	                }
	                // If a function is given, call it when the DOM is ready
	                else if (isFunction(selector)) return $(document).ready(selector);
	                    // If a Zepto collection is given, just return it
	                    else if (zepto.isZ(selector)) return selector;else {
	                            // normalize array if an array of nodes is given
	                            if (isArray(selector)) dom = compact(selector);
	                            // Wrap DOM nodes.
	                            else if (isObject(selector)) dom = [selector], selector = null;
	                                // If it's a html fragment, create nodes from it
	                                else if (fragmentRE.test(selector)) dom = zepto.fragment(selector.trim(), RegExp.$1, context), selector = null;
	                                    // If there's a context, create a collection on that context first, and select
	                                    // nodes from there
	                                    else if (context !== undefined) return $(context).find(selector);
	                                        // And last but no least, if it's a CSS selector, use it to select nodes.
	                                        else dom = zepto.qsa(document, selector);
	                        }
	            // create a new Zepto collection from the nodes found
	            return zepto.Z(dom, selector);
	        };
	
	        // `$` will be the base `Zepto` object. When calling this
	        // function just call `$.zepto.init, which makes the implementation
	        // details of selecting nodes and creating Zepto collections
	        // patchable in plugins.
	        $ = function (selector, context) {
	            return zepto.init(selector, context);
	        };
	
	        function extend(target, source, deep) {
	            for (key in source) if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
	                if (isPlainObject(source[key]) && !isPlainObject(target[key])) target[key] = {};
	                if (isArray(source[key]) && !isArray(target[key])) target[key] = [];
	                extend(target[key], source[key], deep);
	            } else if (source[key] !== undefined) target[key] = source[key];
	        }
	
	        // Copy all but undefined properties from one or more
	        // objects to the `target` object.
	        $.extend = function (target) {
	            var deep,
	                args = slice.call(arguments, 1);
	            if (typeof target == 'boolean') {
	                deep = target;
	                target = args.shift();
	            }
	            args.forEach(function (arg) {
	                extend(target, arg, deep);
	            });
	            return target;
	        };
	
	        // `$.zepto.qsa` is Zepto's CSS selector implementation which
	        // uses `document.querySelectorAll` and optimizes for some special cases, like `#id`.
	        // This method can be overridden in plugins.
	        zepto.qsa = function (element, selector) {
	            var found,
	                maybeID = selector[0] == '#',
	                maybeClass = !maybeID && selector[0] == '.',
	                nameOnly = maybeID || maybeClass ? selector.slice(1) : selector,
	                // Ensure that a 1 char tag name still gets checked
	            isSimple = simpleSelectorRE.test(nameOnly);
	            return element.getElementById && isSimple && maybeID ? // Safari DocumentFragment doesn't have getElementById
	            (found = element.getElementById(nameOnly)) ? [found] : [] : element.nodeType !== 1 && element.nodeType !== 9 && element.nodeType !== 11 ? [] : slice.call(isSimple && !maybeID && element.getElementsByClassName ? // DocumentFragment doesn't have getElementsByClassName/TagName
	            maybeClass ? element.getElementsByClassName(nameOnly) : // If it's simple, it could be a class
	            element.getElementsByTagName(selector) : // Or a tag
	            element.querySelectorAll(selector) // Or it's not simple, and we need to query all
	            );
	        };
	
	        function filtered(nodes, selector) {
	            return selector == null ? $(nodes) : $(nodes).filter(selector);
	        }
	
	        $.contains = document.documentElement.contains ? function (parent, node) {
	            return parent !== node && parent.contains(node);
	        } : function (parent, node) {
	            while (node && (node = node.parentNode)) if (node === parent) return true;
	            return false;
	        };
	
	        function funcArg(context, arg, idx, payload) {
	            return isFunction(arg) ? arg.call(context, idx, payload) : arg;
	        }
	
	        function setAttribute(node, name, value) {
	            value == null ? node.removeAttribute(name) : node.setAttribute(name, value);
	        }
	
	        // access className property while respecting SVGAnimatedString
	        function className(node, value) {
	            var klass = node.className || '',
	                svg = klass && klass.baseVal !== undefined;
	
	            if (value === undefined) return svg ? klass.baseVal : klass;
	            svg ? klass.baseVal = value : node.className = value;
	        }
	
	        // "true"  => true
	        // "false" => false
	        // "null"  => null
	        // "42"    => 42
	        // "42.5"  => 42.5
	        // "08"    => "08"
	        // JSON    => parse if valid
	        // String  => self
	        function deserializeValue(value) {
	            try {
	                return value ? value == "true" || (value == "false" ? false : value == "null" ? null : +value + "" == value ? +value : /^[\[\{]/.test(value) ? $.parseJSON(value) : value) : value;
	            } catch (e) {
	                return value;
	            }
	        }
	
	        $.type = type;
	        $.isFunction = isFunction;
	        $.isWindow = isWindow;
	        $.isArray = isArray;
	        $.isPlainObject = isPlainObject;
	
	        $.isEmptyObject = function (obj) {
	            var name;
	            for (name in obj) return false;
	            return true;
	        };
	
	        $.isNumeric = function (val) {
	            var num = Number(val),
	                type = typeof val;
	            return val != null && type != 'boolean' && (type != 'string' || val.length) && !isNaN(num) && isFinite(num) || false;
	        };
	
	        $.inArray = function (elem, array, i) {
	            return emptyArray.indexOf.call(array, elem, i);
	        };
	
	        $.camelCase = camelize;
	        $.trim = function (str) {
	            return str == null ? "" : String.prototype.trim.call(str);
	        };
	
	        // plugin compatibility
	        $.uuid = 0;
	        $.support = {};
	        $.expr = {};
	        $.noop = function () {};
	
	        $.map = function (elements, callback) {
	            var value,
	                values = [],
	                i,
	                key;
	            if (likeArray(elements)) for (i = 0; i < elements.length; i++) {
	                value = callback(elements[i], i);
	                if (value != null) values.push(value);
	            } else for (key in elements) {
	                value = callback(elements[key], key);
	                if (value != null) values.push(value);
	            }
	            return flatten(values);
	        };
	
	        $.each = function (elements, callback) {
	            var i, key;
	            if (likeArray(elements)) {
	                for (i = 0; i < elements.length; i++) if (callback.call(elements[i], i, elements[i]) === false) return elements;
	            } else {
	                for (key in elements) if (callback.call(elements[key], key, elements[key]) === false) return elements;
	            }
	
	            return elements;
	        };
	
	        $.grep = function (elements, callback) {
	            return filter.call(elements, callback);
	        };
	
	        if (window.JSON) $.parseJSON = JSON.parse;
	
	        // Populate the class2type map
	        $.each("Boolean Number String Function Array Date RegExp Object Error".split(" "), function (i, name) {
	            class2type["[object " + name + "]"] = name.toLowerCase();
	        });
	
	        // Define methods that will be available on all
	        // Zepto collections
	        $.fn = {
	            constructor: zepto.Z,
	            length: 0,
	
	            // Because a collection acts like an array
	            // copy over these useful array functions.
	            forEach: emptyArray.forEach,
	            reduce: emptyArray.reduce,
	            push: emptyArray.push,
	            sort: emptyArray.sort,
	            splice: emptyArray.splice,
	            indexOf: emptyArray.indexOf,
	            concat: function () {
	                var i,
	                    value,
	                    args = [];
	                for (i = 0; i < arguments.length; i++) {
	                    value = arguments[i];
	                    args[i] = zepto.isZ(value) ? value.toArray() : value;
	                }
	                return concat.apply(zepto.isZ(this) ? this.toArray() : this, args);
	            },
	
	            // `map` and `slice` in the jQuery API work differently
	            // from their array counterparts
	            map: function (fn) {
	                return $($.map(this, function (el, i) {
	                    return fn.call(el, i, el);
	                }));
	            },
	            slice: function () {
	                return $(slice.apply(this, arguments));
	            },
	
	            ready: function (callback) {
	                // need to check if document.body exists for IE as that browser reports
	                // document ready when it hasn't yet created the body element
	                if (readyRE.test(document.readyState) && document.body) callback($);else document.addEventListener('DOMContentLoaded', function () {
	                    callback($);
	                }, false);
	                return this;
	            },
	            get: function (idx) {
	                return idx === undefined ? slice.call(this) : this[idx >= 0 ? idx : idx + this.length];
	            },
	            toArray: function () {
	                return this.get();
	            },
	            size: function () {
	                return this.length;
	            },
	            remove: function () {
	                return this.each(function () {
	                    if (this.parentNode != null) this.parentNode.removeChild(this);
	                });
	            },
	            each: function (callback) {
	                emptyArray.every.call(this, function (el, idx) {
	                    return callback.call(el, idx, el) !== false;
	                });
	                return this;
	            },
	            filter: function (selector) {
	                if (isFunction(selector)) return this.not(this.not(selector));
	                return $(filter.call(this, function (element) {
	                    return zepto.matches(element, selector);
	                }));
	            },
	            add: function (selector, context) {
	                return $(uniq(this.concat($(selector, context))));
	            },
	            is: function (selector) {
	                return this.length > 0 && zepto.matches(this[0], selector);
	            },
	            not: function (selector) {
	                var nodes = [];
	                if (isFunction(selector) && selector.call !== undefined) this.each(function (idx) {
	                    if (!selector.call(this, idx)) nodes.push(this);
	                });else {
	                    var excludes = typeof selector == 'string' ? this.filter(selector) : likeArray(selector) && isFunction(selector.item) ? slice.call(selector) : $(selector);
	                    this.forEach(function (el) {
	                        if (excludes.indexOf(el) < 0) nodes.push(el);
	                    });
	                }
	                return $(nodes);
	            },
	            has: function (selector) {
	                return this.filter(function () {
	                    return isObject(selector) ? $.contains(this, selector) : $(this).find(selector).size();
	                });
	            },
	            eq: function (idx) {
	                return idx === -1 ? this.slice(idx) : this.slice(idx, +idx + 1);
	            },
	            first: function () {
	                var el = this[0];
	                return el && !isObject(el) ? el : $(el);
	            },
	            last: function () {
	                var el = this[this.length - 1];
	                return el && !isObject(el) ? el : $(el);
	            },
	            find: function (selector) {
	                var result,
	                    $this = this;
	                if (!selector) result = $();else if (typeof selector == 'object') result = $(selector).filter(function () {
	                    var node = this;
	                    return emptyArray.some.call($this, function (parent) {
	                        return $.contains(parent, node);
	                    });
	                });else if (this.length == 1) result = $(zepto.qsa(this[0], selector));else result = this.map(function () {
	                    return zepto.qsa(this, selector);
	                });
	                return result;
	            },
	            closest: function (selector, context) {
	                var nodes = [],
	                    collection = typeof selector == 'object' && $(selector);
	                this.each(function (_, node) {
	                    while (node && !(collection ? collection.indexOf(node) >= 0 : zepto.matches(node, selector))) node = node !== context && !isDocument(node) && node.parentNode;
	                    if (node && nodes.indexOf(node) < 0) nodes.push(node);
	                });
	                return $(nodes);
	            },
	            parents: function (selector) {
	                var ancestors = [],
	                    nodes = this;
	                while (nodes.length > 0) nodes = $.map(nodes, function (node) {
	                    if ((node = node.parentNode) && !isDocument(node) && ancestors.indexOf(node) < 0) {
	                        ancestors.push(node);
	                        return node;
	                    }
	                });
	                return filtered(ancestors, selector);
	            },
	            parent: function (selector) {
	                return filtered(uniq(this.pluck('parentNode')), selector);
	            },
	            children: function (selector) {
	                return filtered(this.map(function () {
	                    return children(this);
	                }), selector);
	            },
	            contents: function () {
	                return this.map(function () {
	                    return this.contentDocument || slice.call(this.childNodes);
	                });
	            },
	            siblings: function (selector) {
	                return filtered(this.map(function (i, el) {
	                    return filter.call(children(el.parentNode), function (child) {
	                        return child !== el;
	                    });
	                }), selector);
	            },
	            empty: function () {
	                return this.each(function () {
	                    this.innerHTML = '';
	                });
	            },
	            // `pluck` is borrowed from Prototype.js
	            pluck: function (property) {
	                return $.map(this, function (el) {
	                    return el[property];
	                });
	            },
	            show: function () {
	                return this.each(function () {
	                    this.style.display == "none" && (this.style.display = '');
	                    if (getComputedStyle(this, '').getPropertyValue("display") == "none") this.style.display = defaultDisplay(this.nodeName);
	                });
	            },
	            replaceWith: function (newContent) {
	                return this.before(newContent).remove();
	            },
	            wrap: function (structure) {
	                var func = isFunction(structure);
	                if (this[0] && !func) var dom = $(structure).get(0),
	                    clone = dom.parentNode || this.length > 1;
	
	                return this.each(function (index) {
	                    $(this).wrapAll(func ? structure.call(this, index) : clone ? dom.cloneNode(true) : dom);
	                });
	            },
	            wrapAll: function (structure) {
	                if (this[0]) {
	                    $(this[0]).before(structure = $(structure));
	                    var children;
	                    // drill down to the inmost element
	                    while ((children = structure.children()).length) structure = children.first();
	                    $(structure).append(this);
	                }
	                return this;
	            },
	            wrapInner: function (structure) {
	                var func = isFunction(structure);
	                return this.each(function (index) {
	                    var self = $(this),
	                        contents = self.contents(),
	                        dom = func ? structure.call(this, index) : structure;
	                    contents.length ? contents.wrapAll(dom) : self.append(dom);
	                });
	            },
	            unwrap: function () {
	                this.parent().each(function () {
	                    $(this).replaceWith($(this).children());
	                });
	                return this;
	            },
	            clone: function () {
	                return this.map(function () {
	                    return this.cloneNode(true);
	                });
	            },
	            hide: function () {
	                return this.css("display", "none");
	            },
	            toggle: function (setting) {
	                return this.each(function () {
	                    var el = $(this);(setting === undefined ? el.css("display") == "none" : setting) ? el.show() : el.hide();
	                });
	            },
	            prev: function (selector) {
	                return $(this.pluck('previousElementSibling')).filter(selector || '*');
	            },
	            next: function (selector) {
	                return $(this.pluck('nextElementSibling')).filter(selector || '*');
	            },
	            html: function (html) {
	                return 0 in arguments ? this.each(function (idx) {
	                    var originHtml = this.innerHTML;
	                    $(this).empty().append(funcArg(this, html, idx, originHtml));
	                }) : 0 in this ? this[0].innerHTML : null;
	            },
	            text: function (text) {
	                return 0 in arguments ? this.each(function (idx) {
	                    var newText = funcArg(this, text, idx, this.textContent);
	                    this.textContent = newText == null ? '' : '' + newText;
	                }) : 0 in this ? this.pluck('textContent').join("") : null;
	            },
	            attr: function (name, value) {
	                var result;
	                return typeof name == 'string' && !(1 in arguments) ? 0 in this && this[0].nodeType == 1 && (result = this[0].getAttribute(name)) != null ? result : undefined : this.each(function (idx) {
	                    if (this.nodeType !== 1) return;
	                    if (isObject(name)) for (key in name) setAttribute(this, key, name[key]);else setAttribute(this, name, funcArg(this, value, idx, this.getAttribute(name)));
	                });
	            },
	            removeAttr: function (name) {
	                return this.each(function () {
	                    this.nodeType === 1 && name.split(' ').forEach(function (attribute) {
	                        setAttribute(this, attribute);
	                    }, this);
	                });
	            },
	            prop: function (name, value) {
	                name = propMap[name] || name;
	                return 1 in arguments ? this.each(function (idx) {
	                    this[name] = funcArg(this, value, idx, this[name]);
	                }) : this[0] && this[0][name];
	            },
	            removeProp: function (name) {
	                name = propMap[name] || name;
	                return this.each(function () {
	                    delete this[name];
	                });
	            },
	            data: function (name, value) {
	                var attrName = 'data-' + name.replace(capitalRE, '-$1').toLowerCase();
	
	                var data = 1 in arguments ? this.attr(attrName, value) : this.attr(attrName);
	
	                return data !== null ? deserializeValue(data) : undefined;
	            },
	            val: function (value) {
	                if (0 in arguments) {
	                    if (value == null) value = "";
	                    return this.each(function (idx) {
	                        this.value = funcArg(this, value, idx, this.value);
	                    });
	                } else {
	                    return this[0] && (this[0].multiple ? $(this[0]).find('option').filter(function () {
	                        return this.selected;
	                    }).pluck('value') : this[0].value);
	                }
	            },
	            offset: function (coordinates) {
	                if (coordinates) return this.each(function (index) {
	                    var $this = $(this),
	                        coords = funcArg(this, coordinates, index, $this.offset()),
	                        parentOffset = $this.offsetParent().offset(),
	                        props = {
	                        top: coords.top - parentOffset.top,
	                        left: coords.left - parentOffset.left
	                    };
	
	                    if ($this.css('position') == 'static') props['position'] = 'relative';
	                    $this.css(props);
	                });
	                if (!this.length) return null;
	                if (document.documentElement !== this[0] && !$.contains(document.documentElement, this[0])) return { top: 0, left: 0 };
	                var obj = this[0].getBoundingClientRect();
	                return {
	                    left: obj.left + window.pageXOffset,
	                    top: obj.top + window.pageYOffset,
	                    width: Math.round(obj.width),
	                    height: Math.round(obj.height)
	                };
	            },
	            css: function (property, value) {
	                if (arguments.length < 2) {
	                    var element = this[0];
	                    if (typeof property == 'string') {
	                        if (!element) return;
	                        return element.style[camelize(property)] || getComputedStyle(element, '').getPropertyValue(property);
	                    } else if (isArray(property)) {
	                        if (!element) return;
	                        var props = {};
	                        var computedStyle = getComputedStyle(element, '');
	                        $.each(property, function (_, prop) {
	                            props[prop] = element.style[camelize(prop)] || computedStyle.getPropertyValue(prop);
	                        });
	                        return props;
	                    }
	                }
	
	                var css = '';
	                if (type(property) == 'string') {
	                    if (!value && value !== 0) this.each(function () {
	                        this.style.removeProperty(dasherize(property));
	                    });else css = dasherize(property) + ":" + maybeAddPx(property, value);
	                } else {
	                    for (key in property) if (!property[key] && property[key] !== 0) this.each(function () {
	                        this.style.removeProperty(dasherize(key));
	                    });else css += dasherize(key) + ':' + maybeAddPx(key, property[key]) + ';';
	                }
	
	                return this.each(function () {
	                    this.style.cssText += ';' + css;
	                });
	            },
	            index: function (element) {
	                return element ? this.indexOf($(element)[0]) : this.parent().children().indexOf(this[0]);
	            },
	            hasClass: function (name) {
	                if (!name) return false;
	                return emptyArray.some.call(this, function (el) {
	                    return this.test(className(el));
	                }, classRE(name));
	            },
	            addClass: function (name) {
	                if (!name) return this;
	                return this.each(function (idx) {
	                    if (!('className' in this)) return;
	                    classList = [];
	                    var cls = className(this),
	                        newName = funcArg(this, name, idx, cls);
	                    newName.split(/\s+/g).forEach(function (klass) {
	                        if (!$(this).hasClass(klass)) classList.push(klass);
	                    }, this);
	                    classList.length && className(this, cls + (cls ? " " : "") + classList.join(" "));
	                });
	            },
	            removeClass: function (name) {
	                return this.each(function (idx) {
	                    if (!('className' in this)) return;
	                    if (name === undefined) return className(this, '');
	                    classList = className(this);
	                    funcArg(this, name, idx, classList).split(/\s+/g).forEach(function (klass) {
	                        classList = classList.replace(classRE(klass), " ");
	                    });
	                    className(this, classList.trim());
	                });
	            },
	            toggleClass: function (name, when) {
	                if (!name) return this;
	                return this.each(function (idx) {
	                    var $this = $(this),
	                        names = funcArg(this, name, idx, className(this));
	                    names.split(/\s+/g).forEach(function (klass) {
	                        (when === undefined ? !$this.hasClass(klass) : when) ? $this.addClass(klass) : $this.removeClass(klass);
	                    });
	                });
	            },
	            scrollTop: function (value) {
	                if (!this.length) return;
	                var hasScrollTop = 'scrollTop' in this[0];
	                if (value === undefined) return hasScrollTop ? this[0].scrollTop : this[0].pageYOffset;
	                return this.each(hasScrollTop ? function () {
	                    this.scrollTop = value;
	                } : function () {
	                    this.scrollTo(this.scrollX, value);
	                });
	            },
	            scrollLeft: function (value) {
	                if (!this.length) return;
	                var hasScrollLeft = 'scrollLeft' in this[0];
	                if (value === undefined) return hasScrollLeft ? this[0].scrollLeft : this[0].pageXOffset;
	                return this.each(hasScrollLeft ? function () {
	                    this.scrollLeft = value;
	                } : function () {
	                    this.scrollTo(value, this.scrollY);
	                });
	            },
	            position: function () {
	                if (!this.length) return;
	
	                var elem = this[0],
	
	                // Get *real* offsetParent
	                offsetParent = this.offsetParent(),
	
	                // Get correct offsets
	                offset = this.offset(),
	                    parentOffset = rootNodeRE.test(offsetParent[0].nodeName) ? { top: 0, left: 0 } : offsetParent.offset();
	
	                // Subtract element margins
	                // note: when an element has margin: auto the offsetLeft and marginLeft
	                // are the same in Safari causing offset.left to incorrectly be 0
	                offset.top -= parseFloat($(elem).css('margin-top')) || 0;
	                offset.left -= parseFloat($(elem).css('margin-left')) || 0;
	
	                // Add offsetParent borders
	                parentOffset.top += parseFloat($(offsetParent[0]).css('border-top-width')) || 0;
	                parentOffset.left += parseFloat($(offsetParent[0]).css('border-left-width')) || 0;
	
	                // Subtract the two offsets
	                return {
	                    top: offset.top - parentOffset.top,
	                    left: offset.left - parentOffset.left
	                };
	            },
	            offsetParent: function () {
	                return this.map(function () {
	                    var parent = this.offsetParent || document.body;
	                    while (parent && !rootNodeRE.test(parent.nodeName) && $(parent).css("position") == "static") parent = parent.offsetParent;
	                    return parent;
	                });
	            }
	        };
	
	        // for now
	        $.fn.detach = $.fn.remove
	
	        // Generate the `width` and `height` functions
	        ;['width', 'height'].forEach(function (dimension) {
	            var dimensionProperty = dimension.replace(/./, function (m) {
	                return m[0].toUpperCase();
	            });
	
	            $.fn[dimension] = function (value) {
	                var offset,
	                    el = this[0];
	                if (value === undefined) return isWindow(el) ? el['inner' + dimensionProperty] : isDocument(el) ? el.documentElement['scroll' + dimensionProperty] : (offset = this.offset()) && offset[dimension];else return this.each(function (idx) {
	                    el = $(this);
	                    el.css(dimension, funcArg(this, value, idx, el[dimension]()));
	                });
	            };
	        });
	
	        function traverseNode(node, fun) {
	            fun(node);
	            for (var i = 0, len = node.childNodes.length; i < len; i++) traverseNode(node.childNodes[i], fun);
	        }
	
	        // Generate the `after`, `prepend`, `before`, `append`,
	        // `insertAfter`, `insertBefore`, `appendTo`, and `prependTo` methods.
	        adjacencyOperators.forEach(function (operator, operatorIndex) {
	            var inside = operatorIndex % 2; //=> prepend, append
	
	            $.fn[operator] = function () {
	                // arguments can be nodes, arrays of nodes, Zepto objects and HTML strings
	                var argType,
	                    nodes = $.map(arguments, function (arg) {
	                    var arr = [];
	                    argType = type(arg);
	                    if (argType == "array") {
	                        arg.forEach(function (el) {
	                            if (el.nodeType !== undefined) return arr.push(el);else if ($.zepto.isZ(el)) return arr = arr.concat(el.get());
	                            arr = arr.concat(zepto.fragment(el));
	                        });
	                        return arr;
	                    }
	                    return argType == "object" || arg == null ? arg : zepto.fragment(arg);
	                }),
	                    parent,
	                    copyByClone = this.length > 1;
	                if (nodes.length < 1) return this;
	
	                return this.each(function (_, target) {
	                    parent = inside ? target : target.parentNode;
	
	                    // convert all methods to a "before" operation
	                    target = operatorIndex == 0 ? target.nextSibling : operatorIndex == 1 ? target.firstChild : operatorIndex == 2 ? target : null;
	
	                    var parentInDocument = $.contains(document.documentElement, parent);
	
	                    nodes.forEach(function (node) {
	                        if (copyByClone) node = node.cloneNode(true);else if (!parent) return $(node).remove();
	
	                        parent.insertBefore(node, target);
	                        if (parentInDocument) traverseNode(node, function (el) {
	                            if (el.nodeName != null && el.nodeName.toUpperCase() === 'SCRIPT' && (!el.type || el.type === 'text/javascript') && !el.src) {
	                                var target = el.ownerDocument ? el.ownerDocument.defaultView : window;
	                                target['eval'].call(target, el.innerHTML);
	                            }
	                        });
	                    });
	                });
	            };
	
	            // after    => insertAfter
	            // prepend  => prependTo
	            // before   => insertBefore
	            // append   => appendTo
	            $.fn[inside ? operator + 'To' : 'insert' + (operatorIndex ? 'Before' : 'After')] = function (html) {
	                $(html)[operator](this);
	                return this;
	            };
	        });
	
	        zepto.Z.prototype = Z.prototype = $.fn;
	
	        // Export internal API functions in the `$.zepto` namespace
	        zepto.uniq = uniq;
	        zepto.deserializeValue = deserializeValue;
	        $.zepto = zepto;
	
	        return $;
	    }();
	
	    window.Zepto = Zepto;
	    window.$ === undefined && (window.$ = Zepto);(function ($) {
	        var _zid = 1,
	            undefined,
	            slice = Array.prototype.slice,
	            isFunction = $.isFunction,
	            isString = function (obj) {
	            return typeof obj == 'string';
	        },
	            handlers = {},
	            specialEvents = {},
	            focusinSupported = 'onfocusin' in window,
	            focus = { focus: 'focusin', blur: 'focusout' },
	            hover = { mouseenter: 'mouseover', mouseleave: 'mouseout' };
	
	        specialEvents.click = specialEvents.mousedown = specialEvents.mouseup = specialEvents.mousemove = 'MouseEvents';
	
	        function zid(element) {
	            return element._zid || (element._zid = _zid++);
	        }
	        function findHandlers(element, event, fn, selector) {
	            event = parse(event);
	            if (event.ns) var matcher = matcherFor(event.ns);
	            return (handlers[zid(element)] || []).filter(function (handler) {
	                return handler && (!event.e || handler.e == event.e) && (!event.ns || matcher.test(handler.ns)) && (!fn || zid(handler.fn) === zid(fn)) && (!selector || handler.sel == selector);
	            });
	        }
	        function parse(event) {
	            var parts = ('' + event).split('.');
	            return { e: parts[0], ns: parts.slice(1).sort().join(' ') };
	        }
	        function matcherFor(ns) {
	            return new RegExp('(?:^| )' + ns.replace(' ', ' .* ?') + '(?: |$)');
	        }
	
	        function eventCapture(handler, captureSetting) {
	            return handler.del && !focusinSupported && handler.e in focus || !!captureSetting;
	        }
	
	        function realEvent(type) {
	            return hover[type] || focusinSupported && focus[type] || type;
	        }
	
	        function add(element, events, fn, data, selector, delegator, capture) {
	            var id = zid(element),
	                set = handlers[id] || (handlers[id] = []);
	            events.split(/\s/).forEach(function (event) {
	                if (event == 'ready') return $(document).ready(fn);
	                var handler = parse(event);
	                handler.fn = fn;
	                handler.sel = selector;
	                // emulate mouseenter, mouseleave
	                if (handler.e in hover) fn = function (e) {
	                    var related = e.relatedTarget;
	                    if (!related || related !== this && !$.contains(this, related)) return handler.fn.apply(this, arguments);
	                };
	                handler.del = delegator;
	                var callback = delegator || fn;
	                handler.proxy = function (e) {
	                    e = compatible(e);
	                    if (e.isImmediatePropagationStopped()) return;
	                    e.data = data;
	                    var result = callback.apply(element, e._args == undefined ? [e] : [e].concat(e._args));
	                    if (result === false) e.preventDefault(), e.stopPropagation();
	                    return result;
	                };
	                handler.i = set.length;
	                set.push(handler);
	                if ('addEventListener' in element) element.addEventListener(realEvent(handler.e), handler.proxy, eventCapture(handler, capture));
	            });
	        }
	        function remove(element, events, fn, selector, capture) {
	            var id = zid(element);(events || '').split(/\s/).forEach(function (event) {
	                findHandlers(element, event, fn, selector).forEach(function (handler) {
	                    delete handlers[id][handler.i];
	                    if ('removeEventListener' in element) element.removeEventListener(realEvent(handler.e), handler.proxy, eventCapture(handler, capture));
	                });
	            });
	        }
	
	        $.event = { add: add, remove: remove };
	
	        $.proxy = function (fn, context) {
	            var args = 2 in arguments && slice.call(arguments, 2);
	            if (isFunction(fn)) {
	                var proxyFn = function () {
	                    return fn.apply(context, args ? args.concat(slice.call(arguments)) : arguments);
	                };
	                proxyFn._zid = zid(fn);
	                return proxyFn;
	            } else if (isString(context)) {
	                if (args) {
	                    args.unshift(fn[context], fn);
	                    return $.proxy.apply(null, args);
	                } else {
	                    return $.proxy(fn[context], fn);
	                }
	            } else {
	                throw new TypeError("expected function");
	            }
	        };
	
	        $.fn.bind = function (event, data, callback) {
	            return this.on(event, data, callback);
	        };
	        $.fn.unbind = function (event, callback) {
	            return this.off(event, callback);
	        };
	        $.fn.one = function (event, selector, data, callback) {
	            return this.on(event, selector, data, callback, 1);
	        };
	
	        var returnTrue = function () {
	            return true;
	        },
	            returnFalse = function () {
	            return false;
	        },
	            ignoreProperties = /^([A-Z]|returnValue$|layer[XY]$|webkitMovement[XY]$)/,
	            eventMethods = {
	            preventDefault: 'isDefaultPrevented',
	            stopImmediatePropagation: 'isImmediatePropagationStopped',
	            stopPropagation: 'isPropagationStopped'
	        };
	
	        function compatible(event, source) {
	            if (source || !event.isDefaultPrevented) {
	                source || (source = event);
	
	                $.each(eventMethods, function (name, predicate) {
	                    var sourceMethod = source[name];
	                    event[name] = function () {
	                        this[predicate] = returnTrue;
	                        return sourceMethod && sourceMethod.apply(source, arguments);
	                    };
	                    event[predicate] = returnFalse;
	                });
	
	                event.timeStamp || (event.timeStamp = Date.now());
	
	                if (source.defaultPrevented !== undefined ? source.defaultPrevented : 'returnValue' in source ? source.returnValue === false : source.getPreventDefault && source.getPreventDefault()) event.isDefaultPrevented = returnTrue;
	            }
	            return event;
	        }
	
	        function createProxy(event) {
	            var key,
	                proxy = { originalEvent: event };
	            for (key in event) if (!ignoreProperties.test(key) && event[key] !== undefined) proxy[key] = event[key];
	
	            return compatible(proxy, event);
	        }
	
	        $.fn.delegate = function (selector, event, callback) {
	            return this.on(event, selector, callback);
	        };
	        $.fn.undelegate = function (selector, event, callback) {
	            return this.off(event, selector, callback);
	        };
	
	        $.fn.live = function (event, callback) {
	            $(document.body).delegate(this.selector, event, callback);
	            return this;
	        };
	        $.fn.die = function (event, callback) {
	            $(document.body).undelegate(this.selector, event, callback);
	            return this;
	        };
	
	        $.fn.on = function (event, selector, data, callback, one) {
	            var autoRemove,
	                delegator,
	                $this = this;
	            if (event && !isString(event)) {
	                $.each(event, function (type, fn) {
	                    $this.on(type, selector, data, fn, one);
	                });
	                return $this;
	            }
	
	            if (!isString(selector) && !isFunction(callback) && callback !== false) callback = data, data = selector, selector = undefined;
	            if (callback === undefined || data === false) callback = data, data = undefined;
	
	            if (callback === false) callback = returnFalse;
	
	            return $this.each(function (_, element) {
	                if (one) autoRemove = function (e) {
	                    remove(element, e.type, callback);
	                    return callback.apply(this, arguments);
	                };
	
	                if (selector) delegator = function (e) {
	                    var evt,
	                        match = $(e.target).closest(selector, element).get(0);
	                    if (match && match !== element) {
	                        evt = $.extend(createProxy(e), { currentTarget: match, liveFired: element });
	                        return (autoRemove || callback).apply(match, [evt].concat(slice.call(arguments, 1)));
	                    }
	                };
	
	                add(element, event, callback, data, selector, delegator || autoRemove);
	            });
	        };
	        $.fn.off = function (event, selector, callback) {
	            var $this = this;
	            if (event && !isString(event)) {
	                $.each(event, function (type, fn) {
	                    $this.off(type, selector, fn);
	                });
	                return $this;
	            }
	
	            if (!isString(selector) && !isFunction(callback) && callback !== false) callback = selector, selector = undefined;
	
	            if (callback === false) callback = returnFalse;
	
	            return $this.each(function () {
	                remove(this, event, callback, selector);
	            });
	        };
	
	        $.fn.trigger = function (event, args) {
	            event = isString(event) || $.isPlainObject(event) ? $.Event(event) : compatible(event);
	            event._args = args;
	            return this.each(function () {
	                // handle focus(), blur() by calling them directly
	                if (event.type in focus && typeof this[event.type] == "function") this[event.type]();
	                // items in the collection might not be DOM elements
	                else if ('dispatchEvent' in this) this.dispatchEvent(event);else $(this).triggerHandler(event, args);
	            });
	        };
	
	        // triggers event handlers on current element just as if an event occurred,
	        // doesn't trigger an actual event, doesn't bubble
	        $.fn.triggerHandler = function (event, args) {
	            var e, result;
	            this.each(function (i, element) {
	                e = createProxy(isString(event) ? $.Event(event) : event);
	                e._args = args;
	                e.target = element;
	                $.each(findHandlers(element, event.type || event), function (i, handler) {
	                    result = handler.proxy(e);
	                    if (e.isImmediatePropagationStopped()) return false;
	                });
	            });
	            return result;
	        }
	
	        // shortcut methods for `.bind(event, fn)` for each event type
	        ;('focusin focusout focus blur load resize scroll unload click dblclick ' + 'mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave ' + 'change select keydown keypress keyup error').split(' ').forEach(function (event) {
	            $.fn[event] = function (callback) {
	                return 0 in arguments ? this.bind(event, callback) : this.trigger(event);
	            };
	        });
	
	        $.Event = function (type, props) {
	            if (!isString(type)) props = type, type = props.type;
	            var event = document.createEvent(specialEvents[type] || 'Events'),
	                bubbles = true;
	            if (props) for (var name in props) name == 'bubbles' ? bubbles = !!props[name] : event[name] = props[name];
	            event.initEvent(type, bubbles, true);
	            return compatible(event);
	        };
	    })(Zepto);(function ($) {
	        var jsonpID = +new Date(),
	            document = window.document,
	            key,
	            name,
	            rscript = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi,
	            scriptTypeRE = /^(?:text|application)\/javascript/i,
	            xmlTypeRE = /^(?:text|application)\/xml/i,
	            jsonType = 'application/json',
	            htmlType = 'text/html',
	            blankRE = /^\s*$/,
	            originAnchor = document.createElement('a');
	
	        originAnchor.href = window.location.href;
	
	        // trigger a custom event and return false if it was cancelled
	        function triggerAndReturn(context, eventName, data) {
	            var event = $.Event(eventName);
	            $(context).trigger(event, data);
	            return !event.isDefaultPrevented();
	        }
	
	        // trigger an Ajax "global" event
	        function triggerGlobal(settings, context, eventName, data) {
	            if (settings.global) return triggerAndReturn(context || document, eventName, data);
	        }
	
	        // Number of active Ajax requests
	        $.active = 0;
	
	        function ajaxStart(settings) {
	            if (settings.global && $.active++ === 0) triggerGlobal(settings, null, 'ajaxStart');
	        }
	        function ajaxStop(settings) {
	            if (settings.global && ! --$.active) triggerGlobal(settings, null, 'ajaxStop');
	        }
	
	        // triggers an extra global event "ajaxBeforeSend" that's like "ajaxSend" but cancelable
	        function ajaxBeforeSend(xhr, settings) {
	            var context = settings.context;
	            if (settings.beforeSend.call(context, xhr, settings) === false || triggerGlobal(settings, context, 'ajaxBeforeSend', [xhr, settings]) === false) return false;
	
	            triggerGlobal(settings, context, 'ajaxSend', [xhr, settings]);
	        }
	        function ajaxSuccess(data, xhr, settings, deferred) {
	            var context = settings.context,
	                status = 'success';
	            settings.success.call(context, data, status, xhr);
	            if (deferred) deferred.resolveWith(context, [data, status, xhr]);
	            triggerGlobal(settings, context, 'ajaxSuccess', [xhr, settings, data]);
	            ajaxComplete(status, xhr, settings);
	        }
	        // type: "timeout", "error", "abort", "parsererror"
	        function ajaxError(error, type, xhr, settings, deferred) {
	            var context = settings.context;
	            settings.error.call(context, xhr, type, error);
	            if (deferred) deferred.rejectWith(context, [xhr, type, error]);
	            triggerGlobal(settings, context, 'ajaxError', [xhr, settings, error || type]);
	            ajaxComplete(type, xhr, settings);
	        }
	        // status: "success", "notmodified", "error", "timeout", "abort", "parsererror"
	        function ajaxComplete(status, xhr, settings) {
	            var context = settings.context;
	            settings.complete.call(context, xhr, status);
	            triggerGlobal(settings, context, 'ajaxComplete', [xhr, settings]);
	            ajaxStop(settings);
	        }
	
	        function ajaxDataFilter(data, type, settings) {
	            if (settings.dataFilter == empty) return data;
	            var context = settings.context;
	            return settings.dataFilter.call(context, data, type);
	        }
	
	        // Empty function, used as default callback
	        function empty() {}
	
	        $.ajaxJSONP = function (options, deferred) {
	            if (!('type' in options)) return $.ajax(options);
	
	            var _callbackName = options.jsonpCallback,
	                callbackName = ($.isFunction(_callbackName) ? _callbackName() : _callbackName) || 'Zepto' + jsonpID++,
	                script = document.createElement('script'),
	                originalCallback = window[callbackName],
	                responseData,
	                abort = function (errorType) {
	                $(script).triggerHandler('error', errorType || 'abort');
	            },
	                xhr = { abort: abort },
	                abortTimeout;
	
	            if (deferred) deferred.promise(xhr);
	
	            $(script).on('load error', function (e, errorType) {
	                clearTimeout(abortTimeout);
	                $(script).off().remove();
	
	                if (e.type == 'error' || !responseData) {
	                    ajaxError(null, errorType || 'error', xhr, options, deferred);
	                } else {
	                    ajaxSuccess(responseData[0], xhr, options, deferred);
	                }
	
	                window[callbackName] = originalCallback;
	                if (responseData && $.isFunction(originalCallback)) originalCallback(responseData[0]);
	
	                originalCallback = responseData = undefined;
	            });
	
	            if (ajaxBeforeSend(xhr, options) === false) {
	                abort('abort');
	                return xhr;
	            }
	
	            window[callbackName] = function () {
	                responseData = arguments;
	            };
	
	            script.src = options.url.replace(/\?(.+)=\?/, '?$1=' + callbackName);
	            document.head.appendChild(script);
	
	            if (options.timeout > 0) abortTimeout = setTimeout(function () {
	                abort('timeout');
	            }, options.timeout);
	
	            return xhr;
	        };
	
	        $.ajaxSettings = {
	            // Default type of request
	            type: 'GET',
	            // Callback that is executed before request
	            beforeSend: empty,
	            // Callback that is executed if the request succeeds
	            success: empty,
	            // Callback that is executed the the server drops error
	            error: empty,
	            // Callback that is executed on request complete (both: error and success)
	            complete: empty,
	            // The context for the callbacks
	            context: null,
	            // Whether to trigger "global" Ajax events
	            global: true,
	            // Transport
	            xhr: function () {
	                return new window.XMLHttpRequest();
	            },
	            // MIME types mapping
	            // IIS returns Javascript as "application/x-javascript"
	            accepts: {
	                script: 'text/javascript, application/javascript, application/x-javascript',
	                json: jsonType,
	                xml: 'application/xml, text/xml',
	                html: htmlType,
	                text: 'text/plain'
	            },
	            // Whether the request is to another domain
	            crossDomain: false,
	            // Default timeout
	            timeout: 0,
	            // Whether data should be serialized to string
	            processData: true,
	            // Whether the browser should be allowed to cache GET responses
	            cache: true,
	            //Used to handle the raw response data of XMLHttpRequest.
	            //This is a pre-filtering function to sanitize the response.
	            //The sanitized response should be returned
	            dataFilter: empty
	        };
	
	        function mimeToDataType(mime) {
	            if (mime) mime = mime.split(';', 2)[0];
	            return mime && (mime == htmlType ? 'html' : mime == jsonType ? 'json' : scriptTypeRE.test(mime) ? 'script' : xmlTypeRE.test(mime) && 'xml') || 'text';
	        }
	
	        function appendQuery(url, query) {
	            if (query == '') return url;
	            return (url + '&' + query).replace(/[&?]{1,2}/, '?');
	        }
	
	        // serialize payload and append it to the URL for GET requests
	        function serializeData(options) {
	            if (options.processData && options.data && $.type(options.data) != "string") options.data = $.param(options.data, options.traditional);
	            if (options.data && (!options.type || options.type.toUpperCase() == 'GET' || 'jsonp' == options.dataType)) options.url = appendQuery(options.url, options.data), options.data = undefined;
	        }
	
	        $.ajax = function (options) {
	            var settings = $.extend({}, options || {}),
	                deferred = $.Deferred && $.Deferred(),
	                urlAnchor,
	                hashIndex;
	            for (key in $.ajaxSettings) if (settings[key] === undefined) settings[key] = $.ajaxSettings[key];
	
	            ajaxStart(settings);
	
	            if (!settings.crossDomain) {
	                urlAnchor = document.createElement('a');
	                urlAnchor.href = settings.url;
	                // cleans up URL for .href (IE only), see https://github.com/madrobby/zepto/pull/1049
	                urlAnchor.href = urlAnchor.href;
	                settings.crossDomain = originAnchor.protocol + '//' + originAnchor.host !== urlAnchor.protocol + '//' + urlAnchor.host;
	            }
	
	            if (!settings.url) settings.url = window.location.toString();
	            if ((hashIndex = settings.url.indexOf('#')) > -1) settings.url = settings.url.slice(0, hashIndex);
	            serializeData(settings);
	
	            var dataType = settings.dataType,
	                hasPlaceholder = /\?.+=\?/.test(settings.url);
	            if (hasPlaceholder) dataType = 'jsonp';
	
	            if (settings.cache === false || (!options || options.cache !== true) && ('script' == dataType || 'jsonp' == dataType)) settings.url = appendQuery(settings.url, '_=' + Date.now());
	
	            if ('jsonp' == dataType) {
	                if (!hasPlaceholder) settings.url = appendQuery(settings.url, settings.jsonp ? settings.jsonp + '=?' : settings.jsonp === false ? '' : 'callback=?');
	                return $.ajaxJSONP(settings, deferred);
	            }
	
	            var mime = settings.accepts[dataType],
	                headers = {},
	                setHeader = function (name, value) {
	                headers[name.toLowerCase()] = [name, value];
	            },
	                protocol = /^([\w-]+:)\/\//.test(settings.url) ? RegExp.$1 : window.location.protocol,
	                xhr = settings.xhr(),
	                nativeSetHeader = xhr.setRequestHeader,
	                abortTimeout;
	
	            if (deferred) deferred.promise(xhr);
	
	            if (!settings.crossDomain) setHeader('X-Requested-With', 'XMLHttpRequest');
	            setHeader('Accept', mime || '*/*');
	            if (mime = settings.mimeType || mime) {
	                if (mime.indexOf(',') > -1) mime = mime.split(',', 2)[0];
	                xhr.overrideMimeType && xhr.overrideMimeType(mime);
	            }
	            if (settings.contentType || settings.contentType !== false && settings.data && settings.type.toUpperCase() != 'GET') setHeader('Content-Type', settings.contentType || 'application/x-www-form-urlencoded');
	
	            if (settings.headers) for (name in settings.headers) setHeader(name, settings.headers[name]);
	            xhr.setRequestHeader = setHeader;
	
	            xhr.onreadystatechange = function () {
	                if (xhr.readyState == 4) {
	                    xhr.onreadystatechange = empty;
	                    clearTimeout(abortTimeout);
	                    var result,
	                        error = false;
	                    if (xhr.status >= 200 && xhr.status < 300 || xhr.status == 304 || xhr.status == 0 && protocol == 'file:') {
	                        dataType = dataType || mimeToDataType(settings.mimeType || xhr.getResponseHeader('content-type'));
	
	                        if (xhr.responseType == 'arraybuffer' || xhr.responseType == 'blob') result = xhr.response;else {
	                            result = xhr.responseText;
	
	                            try {
	                                // http://perfectionkills.com/global-eval-what-are-the-options/
	                                // sanitize response accordingly if data filter callback provided
	                                result = ajaxDataFilter(result, dataType, settings);
	                                if (dataType == 'script') (1, eval)(result);else if (dataType == 'xml') result = xhr.responseXML;else if (dataType == 'json') result = blankRE.test(result) ? null : $.parseJSON(result);
	                            } catch (e) {
	                                error = e;
	                            }
	
	                            if (error) return ajaxError(error, 'parsererror', xhr, settings, deferred);
	                        }
	
	                        ajaxSuccess(result, xhr, settings, deferred);
	                    } else {
	                        ajaxError(xhr.statusText || null, xhr.status ? 'error' : 'abort', xhr, settings, deferred);
	                    }
	                }
	            };
	
	            if (ajaxBeforeSend(xhr, settings) === false) {
	                xhr.abort();
	                ajaxError(null, 'abort', xhr, settings, deferred);
	                return xhr;
	            }
	
	            var async = 'async' in settings ? settings.async : true;
	            xhr.open(settings.type, settings.url, async, settings.username, settings.password);
	
	            if (settings.xhrFields) for (name in settings.xhrFields) xhr[name] = settings.xhrFields[name];
	
	            for (name in headers) nativeSetHeader.apply(xhr, headers[name]);
	
	            if (settings.timeout > 0) abortTimeout = setTimeout(function () {
	                xhr.onreadystatechange = empty;
	                xhr.abort();
	                ajaxError(null, 'timeout', xhr, settings, deferred);
	            }, settings.timeout);
	
	            // avoid sending empty string (#319)
	            xhr.send(settings.data ? settings.data : null);
	            return xhr;
	        };
	
	        // handle optional data/success arguments
	        function parseArguments(url, data, success, dataType) {
	            if ($.isFunction(data)) dataType = success, success = data, data = undefined;
	            if (!$.isFunction(success)) dataType = success, success = undefined;
	            return {
	                url: url,
	                data: data,
	                success: success,
	                dataType: dataType
	            };
	        }
	
	        $.get = function () /* url, data, success, dataType */{
	            return $.ajax(parseArguments.apply(null, arguments));
	        };
	
	        $.post = function () /* url, data, success, dataType */{
	            var options = parseArguments.apply(null, arguments);
	            options.type = 'POST';
	            return $.ajax(options);
	        };
	
	        $.getJSON = function () /* url, data, success */{
	            var options = parseArguments.apply(null, arguments);
	            options.dataType = 'json';
	            return $.ajax(options);
	        };
	
	        $.fn.load = function (url, data, success) {
	            if (!this.length) return this;
	            var self = this,
	                parts = url.split(/\s/),
	                selector,
	                options = parseArguments(url, data, success),
	                callback = options.success;
	            if (parts.length > 1) options.url = parts[0], selector = parts[1];
	            options.success = function (response) {
	                self.html(selector ? $('<div>').html(response.replace(rscript, "")).find(selector) : response);
	                callback && callback.apply(self, arguments);
	            };
	            $.ajax(options);
	            return this;
	        };
	
	        var escape = encodeURIComponent;
	
	        function serialize(params, obj, traditional, scope) {
	            var type,
	                array = $.isArray(obj),
	                hash = $.isPlainObject(obj);
	            $.each(obj, function (key, value) {
	                type = $.type(value);
	                if (scope) key = traditional ? scope : scope + '[' + (hash || type == 'object' || type == 'array' ? key : '') + ']';
	                // handle data in serializeArray() format
	                if (!scope && array) params.add(value.name, value.value);
	                // recurse into nested objects
	                else if (type == "array" || !traditional && type == "object") serialize(params, value, traditional, key);else params.add(key, value);
	            });
	        }
	
	        $.param = function (obj, traditional) {
	            var params = [];
	            params.add = function (key, value) {
	                if ($.isFunction(value)) value = value();
	                if (value == null) value = "";
	                this.push(escape(key) + '=' + escape(value));
	            };
	            serialize(params, obj, traditional);
	            return params.join('&').replace(/%20/g, '+');
	        };
	    })(Zepto);(function ($) {
	        $.fn.serializeArray = function () {
	            var name,
	                type,
	                result = [],
	                add = function (value) {
	                if (value.forEach) return value.forEach(add);
	                result.push({ name: name, value: value });
	            };
	            if (this[0]) $.each(this[0].elements, function (_, field) {
	                type = field.type, name = field.name;
	                if (name && field.nodeName.toLowerCase() != 'fieldset' && !field.disabled && type != 'submit' && type != 'reset' && type != 'button' && type != 'file' && (type != 'radio' && type != 'checkbox' || field.checked)) add($(field).val());
	            });
	            return result;
	        };
	
	        $.fn.serialize = function () {
	            var result = [];
	            this.serializeArray().forEach(function (elm) {
	                result.push(encodeURIComponent(elm.name) + '=' + encodeURIComponent(elm.value));
	            });
	            return result.join('&');
	        };
	
	        $.fn.submit = function (callback) {
	            if (0 in arguments) this.bind('submit', callback);else if (this.length) {
	                var event = $.Event('submit');
	                this.eq(0).trigger(event);
	                if (!event.isDefaultPrevented()) this.get(0).submit();
	            }
	            return this;
	        };
	    })(Zepto);(function () {
	        // getComputedStyle shouldn't freak out when called
	        // without a valid element as argument
	        try {
	            getComputedStyle(undefined);
	        } catch (e) {
	            var nativeGetComputedStyle = getComputedStyle;
	            window.getComputedStyle = function (element, pseudoElement) {
	                try {
	                    return nativeGetComputedStyle(element, pseudoElement);
	                } catch (e) {
	                    return null;
	                }
	            };
	        }
	    })();
	    return Zepto;
	});

/***/ },
/* 3 */,
/* 4 */,
/* 5 */
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function () {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for (var i = 0; i < this.length; i++) {
				var item = this[i];
				if (item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function (modules, mediaQuery) {
			if (typeof modules === "string") modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for (var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if (typeof id === "number") alreadyImportedModules[id] = true;
			}
			for (i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if (typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if (mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if (mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};

/***/ },
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ },
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(27);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept(27, function() {
				var newContent = __webpack_require__(27);
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(5)();
	// imports
	
	
	// module
	exports.push([module.id, ".flex-column{display:flex;flex-direction:column}.product{font-family:latolight,sans-serif;justify-content:center;text-align:center;width:100%;align-items:center;padding-top:.15rem;margin-bottom:.02rem}@media screen and (max-width:414px){.product img{width:50%;padding-top:.5rem;display:block}}.product h3{line-height:1.4rem;font-family:latoregular,sans-serif}.flex-wrap-reverse{flex-flow:row wrap-reverse}.flex-wrap{flex-flow:row wrap}.background-f2f2f2{background:linear-gradient(top,#fafafa,#f0f0f0);background:-webkit-linear-gradient(top,#fafafa,#f0f0f0)}.padding-bottom{margin-bottom:.15rem;padding-top:1rem}.content-news{background:#f2f2f2;padding:2rem 0;font-family:latolight,sans-serif}.content-news h1{padding-left:5%;box-sizing:border-box}.content-news h1,.content-news h2{font-family:latoregular,sans-serif}.content-news h2{font-size:.8rem}.content-news .news a li{width:90%;padding:1rem 5%;line-height:1.5rem;border-bottom:1px solid rgba(0,0,0,.1)}.content-news .news a li time{display:block;color:#8b8b8b}.content-news .news a li time span{color:hsla(0,0%,55%,.6);padding-left:1.5rem}.content-news .news a li h2{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.content-news .news a li p{color:rgba(47,47,47,.6);display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:1;overflow:hidden;height:28px}.content-news .news a:last-child li{border-bottom:none}.app{background:url(" + __webpack_require__(28) + ") no-repeat 50%;height:257px;width:100%;color:#fff;box-sizing:border-box;padding:7% 0 0 5%;font-family:latolight,sans-serif}@media (max-width:466px){.app{background-position:68%}}.app h1{font-family:latoregular,sans-serif}.app a{color:#fff}.app .app-content{padding:6% 0 0 5%}.app .andrid{background:linear-gradient(left,#1d9abf,#5661c3);background:-webkit-linear-gradient(left,#1d9abf,#5661c3)}.app .andrid,.app .ios{width:9.5rem;padding:.2rem .4rem;border-radius:2rem;margin-bottom:1rem}.app .ios{border:.1rem solid hsla(0,0%,100%,.7)}.app .fa:before{font-size:2rem}.app .flex{justify-content:space-around;align-items:center}.products{text-align:center;margin-top:1rem;font-family:latolight,sans-serif}.products h3{font-family:latoregular,sans-serif}.products .flex{flex-flow:row wrap}.products .flex li{width:50%;box-sizing:border-box;padding:10px 5px;border-bottom:1px solid #f0f0f0}.products .flex li:nth-child(2n){border-left:1px solid #f0f0f0}.products .flex li img{width:100%}.follow{text-align:center;padding:1.5rem 0;color:#d0d0d0;font-family:latolight,sans-serif}.follow h1{font-family:latoregular,sans-serif}.follow a{border:2px solid #d0d0d0;border-radius:100%;height:2rem;width:2rem;line-height:2rem;margin:1rem .5rem}.follow .flex{flex-flow:row;justify-content:center;align-items:center}.follow .flex .fa:before{font-size:1rem;color:#d0d0d0;text-align:center;line-height:2rem}#airwheel_weixin{position:fixed;width:100%;height:100%;background:rgba(0,0,0,.5);top:0;z-index:9999;display:none}#airwheel_weixin .weixin{width:15rem;height:18.5rem;background:#fff;border-radius:.5rem;position:fixed;top:50%;left:50%;margin-left:-7.5rem;margin-top:-9rem;overflow:hidden;text-align:center;color:rgba(0,0,0,.6);transform:scaleY(0);transition:all .3s}#airwheel_weixin .weixin.prompt_show{animation:prompt_show .3s ease-in-out;animation-fill-mode:forwards;transform-origin:top}@keyframes prompt_show{0%{transform:scaleY(0)}to{transform:scale(1)}}", ""]);
	
	// exports


/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "./image/020b924946905afd5ddfe3931e118122.jpg";

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function($) {var banner = __webpack_require__(30);
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(32)], __WEBPACK_AMD_DEFINE_RESULT__ = function (swiper) {
		$(function () {
			wscreen = function () {
				var windowhegiht = window.innerWidth / 720;
				var bannerheght = windowhegiht * 710;
				if (window.innerWidth <= 720) {
					$(".banner").height(bannerheght);
				}
			};
			wscreen();
			$(window).resize(function () {
				wscreen();
			});
			var swiper = new Swiper('.swiper-container', {
				pagination: '.swiper-pagination',
				nextButton: '.swiper-button-next',
				prevButton: '.swiper-button-prev',
				slidesPerView: 1,
				paginationClickable: true,
				spaceBetween: 30,
				loop: true,
				spaceBetween: 30,
				keyboardControl: true,
				centeredSlides: true,
				autoplay: 2500,
				autoplayDisableOnInteraction: false
			});
		});
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(31);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept(31, function() {
				var newContent = __webpack_require__(31);
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(5)();
	// imports
	
	
	// module
	exports.push([module.id, ".swiper-container{margin:0 auto;position:relative;overflow:hidden;z-index:1;width:100%;height:100%}.swiper-slide{text-align:center;font-size:18px;background:#fff;display:-webkit-box;display:-ms-flexbox;display:-webkit-flex;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;-webkit-justify-content:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;-webkit-align-items:center;align-items:center;background-repeat:no-repeat}.swiper-slide .md{display:none}@media screen and (max-width:1200px){.swiper-slide{background-size:150% 100%}.swiper-slide .max{display:none}.swiper-slide .md{display:block}}.swiper-pagination-bullet{width:50px;height:2px;display:inline-block;position:relative;opacity:.2;padding:5px 0}.swiper-pagination-bullet:after{content:\"\";background:gray;width:100%;height:2px;display:block;position:absolute;top:0;left:0}.banner{width:100%;position:relative;overflow:hidden;height:662px}.swiper-container-no-flexbox .swiper-slide{float:left}.swiper-container-vertical>.swiper-wrapper{-webkit-box-orient:vertical;-moz-box-orient:vertical;-ms-flex-direction:column;-webkit-flex-direction:column;flex-direction:column}.swiper-wrapper{position:relative;width:100%;height:100%;z-index:1;display:-webkit-box;display:-moz-box;display:-ms-flexbox;display:-webkit-flex;display:flex;-webkit-transition-property:-webkit-transform;-moz-transition-property:-moz-transform;-o-transition-property:-o-transform;-ms-transition-property:-ms-transform;transition-property:transform;-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box}.swiper-container-android .swiper-slide,.swiper-wrapper{-webkit-transform:translateZ(0);-moz-transform:translateZ(0);-o-transform:translate(0);-ms-transform:translateZ(0);transform:translateZ(0)}.swiper-container-multirow>.swiper-wrapper{-webkit-box-lines:multiple;-moz-box-lines:multiple;-ms-flex-wrap:wrap;-webkit-flex-wrap:wrap;flex-wrap:wrap}.swiper-container-free-mode>.swiper-wrapper{-webkit-transition-timing-function:ease-out;-moz-transition-timing-function:ease-out;-ms-transition-timing-function:ease-out;-o-transition-timing-function:ease-out;transition-timing-function:ease-out;margin:0 auto}.swiper-slide{-webkit-flex-shrink:0;-ms-flex:0 0 auto;flex-shrink:0;width:100%;height:100%;position:relative}.swiper-container-autoheight,.swiper-container-autoheight .swiper-slide{height:auto}.swiper-container-autoheight .swiper-wrapper{-webkit-box-align:start;-ms-flex-align:start;-webkit-align-items:flex-start;align-items:flex-start;-webkit-transition-property:-webkit-transform,height;-moz-transition-property:-moz-transform;-o-transition-property:-o-transform;-ms-transition-property:-ms-transform;transition-property:transform,height}.swiper-container .swiper-notification{position:absolute;left:0;top:0;pointer-events:none;opacity:0;z-index:-1000}.swiper-wp8-horizontal{-ms-touch-action:pan-y;touch-action:pan-y}.swiper-wp8-vertical{-ms-touch-action:pan-x;touch-action:pan-x}.swiper-button-next,.swiper-button-prev{position:absolute;top:50%;width:27px;height:44px;margin-top:-22px;z-index:10;cursor:pointer;-moz-background-size:27px 44px;-webkit-background-size:27px 44px;background-size:27px 44px;background-position:50%;background-repeat:no-repeat}.swiper-button-next.swiper-button-disabled,.swiper-button-prev.swiper-button-disabled{opacity:.35;cursor:auto;pointer-events:none}.swiper-pagination{position:absolute;text-align:center;-webkit-transition:.3s;-moz-transition:.3s;-o-transition:.3s;transition:.3s;-webkit-transform:translateZ(0);-ms-transform:translateZ(0);-o-transform:translateZ(0);transform:translateZ(0);z-index:10}.swiper-pagination.swiper-pagination-hidden{opacity:0}.swiper-container-horizontal>.swiper-pagination-bullets,.swiper-pagination-custom,.swiper-pagination-fraction{bottom:-5px;left:0;width:100%}button.swiper-pagination-bullet{border:none;margin:0;padding:0;box-shadow:none;-moz-appearance:none;-ms-appearance:none;-webkit-appearance:none;appearance:none}.swiper-pagination-clickable .swiper-pagination-bullet{cursor:pointer}.swiper-pagination-white .swiper-pagination-bullet{background:#fff}.swiper-pagination-bullet-active{opacity:1}.swiper-pagination-white .swiper-pagination-bullet-active{background:#fff}.swiper-pagination-black .swiper-pagination-bullet-active{background:#000}.swiper-container-vertical>.swiper-pagination-bullets{right:10px;top:50%;-webkit-transform:translate3d(0,-50%,0);-moz-transform:translate3d(0,-50%,0);-o-transform:translateY(-50%);-ms-transform:translate3d(0,-50%,0);transform:translate3d(0,-50%,0)}.swiper-container-vertical>.swiper-pagination-bullets .swiper-pagination-bullet{margin:5px 0;display:block}.swiper-container-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet{margin:0 5px}@-webkit-keyframes swiper-preloader-spin{to{-webkit-transform:rotate(1turn)}}@keyframes swiper-preloader-spin{to{transform:rotate(1turn)}}", ""]);
	
	// exports


/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Swiper 3.3.1
	 * Most modern mobile touch slider and framework with hardware accelerated transitions
	 * 
	 * http://www.idangero.us/swiper/
	 * 
	 * Copyright 2016, Vladimir Kharlampidi
	 * The iDangero.us
	 * http://www.idangero.us/
	 * 
	 * Licensed under MIT
	 * 
	 * Released on: February 7, 2016
	 */
	!function () {
	  "use strict";
	  function e(e) {
	    e.fn.swiper = function (a) {
	      var r;return e(this).each(function () {
	        var e = new t(this, a);r || (r = e);
	      }), r;
	    };
	  }var a,
	      t = function (e, i) {
	    function s(e) {
	      return Math.floor(e);
	    }function n() {
	      b.autoplayTimeoutId = setTimeout(function () {
	        b.params.loop ? (b.fixLoop(), b._slideNext(), b.emit("onAutoplay", b)) : b.isEnd ? i.autoplayStopOnLast ? b.stopAutoplay() : (b._slideTo(0), b.emit("onAutoplay", b)) : (b._slideNext(), b.emit("onAutoplay", b));
	      }, b.params.autoplay);
	    }function o(e, t) {
	      var r = a(e.target);if (!r.is(t)) if ("string" == typeof t) r = r.parents(t);else if (t.nodeType) {
	        var i;return r.parents().each(function (e, a) {
	          a === t && (i = t);
	        }), i ? t : void 0;
	      }if (0 !== r.length) return r[0];
	    }function l(e, a) {
	      a = a || {};var t = window.MutationObserver || window.WebkitMutationObserver,
	          r = new t(function (e) {
	        e.forEach(function (e) {
	          b.onResize(!0), b.emit("onObserverUpdate", b, e);
	        });
	      });r.observe(e, { attributes: "undefined" == typeof a.attributes ? !0 : a.attributes, childList: "undefined" == typeof a.childList ? !0 : a.childList, characterData: "undefined" == typeof a.characterData ? !0 : a.characterData }), b.observers.push(r);
	    }function p(e) {
	      e.originalEvent && (e = e.originalEvent);var a = e.keyCode || e.charCode;if (!b.params.allowSwipeToNext && (b.isHorizontal() && 39 === a || !b.isHorizontal() && 40 === a)) return !1;if (!b.params.allowSwipeToPrev && (b.isHorizontal() && 37 === a || !b.isHorizontal() && 38 === a)) return !1;if (!(e.shiftKey || e.altKey || e.ctrlKey || e.metaKey || document.activeElement && document.activeElement.nodeName && ("input" === document.activeElement.nodeName.toLowerCase() || "textarea" === document.activeElement.nodeName.toLowerCase()))) {
	        if (37 === a || 39 === a || 38 === a || 40 === a) {
	          var t = !1;if (b.container.parents(".swiper-slide").length > 0 && 0 === b.container.parents(".swiper-slide-active").length) return;var r = { left: window.pageXOffset, top: window.pageYOffset },
	              i = window.innerWidth,
	              s = window.innerHeight,
	              n = b.container.offset();b.rtl && (n.left = n.left - b.container[0].scrollLeft);for (var o = [[n.left, n.top], [n.left + b.width, n.top], [n.left, n.top + b.height], [n.left + b.width, n.top + b.height]], l = 0; l < o.length; l++) {
	            var p = o[l];p[0] >= r.left && p[0] <= r.left + i && p[1] >= r.top && p[1] <= r.top + s && (t = !0);
	          }if (!t) return;
	        }b.isHorizontal() ? ((37 === a || 39 === a) && (e.preventDefault ? e.preventDefault() : e.returnValue = !1), (39 === a && !b.rtl || 37 === a && b.rtl) && b.slideNext(), (37 === a && !b.rtl || 39 === a && b.rtl) && b.slidePrev()) : ((38 === a || 40 === a) && (e.preventDefault ? e.preventDefault() : e.returnValue = !1), 40 === a && b.slideNext(), 38 === a && b.slidePrev());
	      }
	    }function d(e) {
	      e.originalEvent && (e = e.originalEvent);var a = b.mousewheel.event,
	          t = 0,
	          r = b.rtl ? -1 : 1;if ("mousewheel" === a) {
	        if (b.params.mousewheelForceToAxis) {
	          if (b.isHorizontal()) {
	            if (!(Math.abs(e.wheelDeltaX) > Math.abs(e.wheelDeltaY))) return;t = e.wheelDeltaX * r;
	          } else {
	            if (!(Math.abs(e.wheelDeltaY) > Math.abs(e.wheelDeltaX))) return;t = e.wheelDeltaY;
	          }
	        } else t = Math.abs(e.wheelDeltaX) > Math.abs(e.wheelDeltaY) ? -e.wheelDeltaX * r : -e.wheelDeltaY;
	      } else if ("DOMMouseScroll" === a) t = -e.detail;else if ("wheel" === a) if (b.params.mousewheelForceToAxis) {
	        if (b.isHorizontal()) {
	          if (!(Math.abs(e.deltaX) > Math.abs(e.deltaY))) return;t = -e.deltaX * r;
	        } else {
	          if (!(Math.abs(e.deltaY) > Math.abs(e.deltaX))) return;t = -e.deltaY;
	        }
	      } else t = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? -e.deltaX * r : -e.deltaY;if (0 !== t) {
	        if (b.params.mousewheelInvert && (t = -t), b.params.freeMode) {
	          var i = b.getWrapperTranslate() + t * b.params.mousewheelSensitivity,
	              s = b.isBeginning,
	              n = b.isEnd;if (i >= b.minTranslate() && (i = b.minTranslate()), i <= b.maxTranslate() && (i = b.maxTranslate()), b.setWrapperTransition(0), b.setWrapperTranslate(i), b.updateProgress(), b.updateActiveIndex(), (!s && b.isBeginning || !n && b.isEnd) && b.updateClasses(), b.params.freeModeSticky ? (clearTimeout(b.mousewheel.timeout), b.mousewheel.timeout = setTimeout(function () {
	            b.slideReset();
	          }, 300)) : b.params.lazyLoading && b.lazy && b.lazy.load(), 0 === i || i === b.maxTranslate()) return;
	        } else {
	          if (new window.Date().getTime() - b.mousewheel.lastScrollTime > 60) if (0 > t) {
	            if (b.isEnd && !b.params.loop || b.animating) {
	              if (b.params.mousewheelReleaseOnEdges) return !0;
	            } else b.slideNext();
	          } else if (b.isBeginning && !b.params.loop || b.animating) {
	            if (b.params.mousewheelReleaseOnEdges) return !0;
	          } else b.slidePrev();b.mousewheel.lastScrollTime = new window.Date().getTime();
	        }return b.params.autoplay && b.stopAutoplay(), e.preventDefault ? e.preventDefault() : e.returnValue = !1, !1;
	      }
	    }function u(e, t) {
	      e = a(e);var r,
	          i,
	          s,
	          n = b.rtl ? -1 : 1;r = e.attr("data-swiper-parallax") || "0", i = e.attr("data-swiper-parallax-x"), s = e.attr("data-swiper-parallax-y"), i || s ? (i = i || "0", s = s || "0") : b.isHorizontal() ? (i = r, s = "0") : (s = r, i = "0"), i = i.indexOf("%") >= 0 ? parseInt(i, 10) * t * n + "%" : i * t * n + "px", s = s.indexOf("%") >= 0 ? parseInt(s, 10) * t + "%" : s * t + "px", e.transform("translate3d(" + i + ", " + s + ",0px)");
	    }function c(e) {
	      return 0 !== e.indexOf("on") && (e = e[0] !== e[0].toUpperCase() ? "on" + e[0].toUpperCase() + e.substring(1) : "on" + e), e;
	    }if (!(this instanceof t)) return new t(e, i);var m = { direction: "horizontal", touchEventsTarget: "container", initialSlide: 0, speed: 300, autoplay: !1, autoplayDisableOnInteraction: !0, autoplayStopOnLast: !1, iOSEdgeSwipeDetection: !1, iOSEdgeSwipeThreshold: 20, freeMode: !1, freeModeMomentum: !0, freeModeMomentumRatio: 1, freeModeMomentumBounce: !0, freeModeMomentumBounceRatio: 1, freeModeSticky: !1, freeModeMinimumVelocity: .02, autoHeight: !1, setWrapperSize: !1, virtualTranslate: !1, effect: "slide", coverflow: { rotate: 50, stretch: 0, depth: 100, modifier: 1, slideShadows: !0 }, flip: { slideShadows: !0, limitRotation: !0 }, cube: { slideShadows: !0, shadow: !0, shadowOffset: 20, shadowScale: .94 }, fade: { crossFade: !1 }, parallax: !1, scrollbar: null, scrollbarHide: !0, scrollbarDraggable: !1, scrollbarSnapOnRelease: !1, keyboardControl: !1, mousewheelControl: !1, mousewheelReleaseOnEdges: !1, mousewheelInvert: !1, mousewheelForceToAxis: !1, mousewheelSensitivity: 1, hashnav: !1, breakpoints: void 0, spaceBetween: 0, slidesPerView: 1, slidesPerColumn: 1, slidesPerColumnFill: "column", slidesPerGroup: 1, centeredSlides: !1, slidesOffsetBefore: 0, slidesOffsetAfter: 0, roundLengths: !1, touchRatio: 1, touchAngle: 45, simulateTouch: !0, shortSwipes: !0, longSwipes: !0, longSwipesRatio: .5, longSwipesMs: 300, followFinger: !0, onlyExternal: !1, threshold: 0, touchMoveStopPropagation: !0, uniqueNavElements: !0, pagination: null, paginationElement: "span", paginationClickable: !1, paginationHide: !1, paginationBulletRender: null, paginationProgressRender: null, paginationFractionRender: null, paginationCustomRender: null, paginationType: "bullets", resistance: !0, resistanceRatio: .85, nextButton: null, prevButton: null, watchSlidesProgress: !1, watchSlidesVisibility: !1, grabCursor: !1, preventClicks: !0, preventClicksPropagation: !0, slideToClickedSlide: !1, lazyLoading: !1, lazyLoadingInPrevNext: !1, lazyLoadingInPrevNextAmount: 1, lazyLoadingOnTransitionStart: !1, preloadImages: !0, updateOnImagesReady: !0, loop: !1, loopAdditionalSlides: 0, loopedSlides: null, control: void 0, controlInverse: !1, controlBy: "slide", allowSwipeToPrev: !0, allowSwipeToNext: !0, swipeHandler: null, noSwiping: !0, noSwipingClass: "swiper-no-swiping", slideClass: "swiper-slide", slideActiveClass: "swiper-slide-active", slideVisibleClass: "swiper-slide-visible", slideDuplicateClass: "swiper-slide-duplicate", slideNextClass: "swiper-slide-next", slidePrevClass: "swiper-slide-prev", wrapperClass: "swiper-wrapper", bulletClass: "swiper-pagination-bullet", bulletActiveClass: "swiper-pagination-bullet-active", buttonDisabledClass: "swiper-button-disabled", paginationCurrentClass: "swiper-pagination-current", paginationTotalClass: "swiper-pagination-total", paginationHiddenClass: "swiper-pagination-hidden", paginationProgressbarClass: "swiper-pagination-progressbar", observer: !1, observeParents: !1, a11y: !1, prevSlideMessage: "Previous slide", nextSlideMessage: "Next slide", firstSlideMessage: "This is the first slide", lastSlideMessage: "This is the last slide", paginationBulletMessage: "Go to slide {{index}}", runCallbacksOnInit: !0 },
	        h = i && i.virtualTranslate;i = i || {};var f = {};for (var g in i) if ("object" != typeof i[g] || null === i[g] || i[g].nodeType || i[g] === window || i[g] === document || "undefined" != typeof r && i[g] instanceof r || "undefined" != typeof jQuery && i[g] instanceof jQuery) f[g] = i[g];else {
	      f[g] = {};for (var v in i[g]) f[g][v] = i[g][v];
	    }for (var w in m) if ("undefined" == typeof i[w]) i[w] = m[w];else if ("object" == typeof i[w]) for (var y in m[w]) "undefined" == typeof i[w][y] && (i[w][y] = m[w][y]);var b = this;if (b.params = i, b.originalParams = f, b.classNames = [], "undefined" != typeof a && "undefined" != typeof r && (a = r), ("undefined" != typeof a || (a = "undefined" == typeof r ? window.Dom7 || window.Zepto || window.jQuery : r)) && (b.$ = a, b.currentBreakpoint = void 0, b.getActiveBreakpoint = function () {
	      if (!b.params.breakpoints) return !1;var e,
	          a = !1,
	          t = [];for (e in b.params.breakpoints) b.params.breakpoints.hasOwnProperty(e) && t.push(e);t.sort(function (e, a) {
	        return parseInt(e, 10) > parseInt(a, 10);
	      });for (var r = 0; r < t.length; r++) e = t[r], e >= window.innerWidth && !a && (a = e);return a || "max";
	    }, b.setBreakpoint = function () {
	      var e = b.getActiveBreakpoint();if (e && b.currentBreakpoint !== e) {
	        var a = e in b.params.breakpoints ? b.params.breakpoints[e] : b.originalParams,
	            t = b.params.loop && a.slidesPerView !== b.params.slidesPerView;for (var r in a) b.params[r] = a[r];b.currentBreakpoint = e, t && b.destroyLoop && b.reLoop(!0);
	      }
	    }, b.params.breakpoints && b.setBreakpoint(), b.container = a(e), 0 !== b.container.length)) {
	      if (b.container.length > 1) {
	        var x = [];return b.container.each(function () {
	          x.push(new t(this, i));
	        }), x;
	      }b.container[0].swiper = b, b.container.data("swiper", b), b.classNames.push("swiper-container-" + b.params.direction), b.params.freeMode && b.classNames.push("swiper-container-free-mode"), b.support.flexbox || (b.classNames.push("swiper-container-no-flexbox"), b.params.slidesPerColumn = 1), b.params.autoHeight && b.classNames.push("swiper-container-autoheight"), (b.params.parallax || b.params.watchSlidesVisibility) && (b.params.watchSlidesProgress = !0), ["cube", "coverflow", "flip"].indexOf(b.params.effect) >= 0 && (b.support.transforms3d ? (b.params.watchSlidesProgress = !0, b.classNames.push("swiper-container-3d")) : b.params.effect = "slide"), "slide" !== b.params.effect && b.classNames.push("swiper-container-" + b.params.effect), "cube" === b.params.effect && (b.params.resistanceRatio = 0, b.params.slidesPerView = 1, b.params.slidesPerColumn = 1, b.params.slidesPerGroup = 1, b.params.centeredSlides = !1, b.params.spaceBetween = 0, b.params.virtualTranslate = !0, b.params.setWrapperSize = !1), ("fade" === b.params.effect || "flip" === b.params.effect) && (b.params.slidesPerView = 1, b.params.slidesPerColumn = 1, b.params.slidesPerGroup = 1, b.params.watchSlidesProgress = !0, b.params.spaceBetween = 0, b.params.setWrapperSize = !1, "undefined" == typeof h && (b.params.virtualTranslate = !0)), b.params.grabCursor && b.support.touch && (b.params.grabCursor = !1), b.wrapper = b.container.children("." + b.params.wrapperClass), b.params.pagination && (b.paginationContainer = a(b.params.pagination), b.params.uniqueNavElements && "string" == typeof b.params.pagination && b.paginationContainer.length > 1 && 1 === b.container.find(b.params.pagination).length && (b.paginationContainer = b.container.find(b.params.pagination)), "bullets" === b.params.paginationType && b.params.paginationClickable ? b.paginationContainer.addClass("swiper-pagination-clickable") : b.params.paginationClickable = !1, b.paginationContainer.addClass("swiper-pagination-" + b.params.paginationType)), (b.params.nextButton || b.params.prevButton) && (b.params.nextButton && (b.nextButton = a(b.params.nextButton), b.params.uniqueNavElements && "string" == typeof b.params.nextButton && b.nextButton.length > 1 && 1 === b.container.find(b.params.nextButton).length && (b.nextButton = b.container.find(b.params.nextButton))), b.params.prevButton && (b.prevButton = a(b.params.prevButton), b.params.uniqueNavElements && "string" == typeof b.params.prevButton && b.prevButton.length > 1 && 1 === b.container.find(b.params.prevButton).length && (b.prevButton = b.container.find(b.params.prevButton)))), b.isHorizontal = function () {
	        return "horizontal" === b.params.direction;
	      }, b.rtl = b.isHorizontal() && ("rtl" === b.container[0].dir.toLowerCase() || "rtl" === b.container.css("direction")), b.rtl && b.classNames.push("swiper-container-rtl"), b.rtl && (b.wrongRTL = "-webkit-box" === b.wrapper.css("display")), b.params.slidesPerColumn > 1 && b.classNames.push("swiper-container-multirow"), b.device.android && b.classNames.push("swiper-container-android"), b.container.addClass(b.classNames.join(" ")), b.translate = 0, b.progress = 0, b.velocity = 0, b.lockSwipeToNext = function () {
	        b.params.allowSwipeToNext = !1;
	      }, b.lockSwipeToPrev = function () {
	        b.params.allowSwipeToPrev = !1;
	      }, b.lockSwipes = function () {
	        b.params.allowSwipeToNext = b.params.allowSwipeToPrev = !1;
	      }, b.unlockSwipeToNext = function () {
	        b.params.allowSwipeToNext = !0;
	      }, b.unlockSwipeToPrev = function () {
	        b.params.allowSwipeToPrev = !0;
	      }, b.unlockSwipes = function () {
	        b.params.allowSwipeToNext = b.params.allowSwipeToPrev = !0;
	      }, b.params.grabCursor && (b.container[0].style.cursor = "move", b.container[0].style.cursor = "-webkit-grab", b.container[0].style.cursor = "-moz-grab", b.container[0].style.cursor = "grab"), b.imagesToLoad = [], b.imagesLoaded = 0, b.loadImage = function (e, a, t, r, i) {
	        function s() {
	          i && i();
	        }var n;e.complete && r ? s() : a ? (n = new window.Image(), n.onload = s, n.onerror = s, t && (n.srcset = t), a && (n.src = a)) : s();
	      }, b.preloadImages = function () {
	        function e() {
	          "undefined" != typeof b && null !== b && (void 0 !== b.imagesLoaded && b.imagesLoaded++, b.imagesLoaded === b.imagesToLoad.length && (b.params.updateOnImagesReady && b.update(), b.emit("onImagesReady", b)));
	        }b.imagesToLoad = b.container.find("img");for (var a = 0; a < b.imagesToLoad.length; a++) b.loadImage(b.imagesToLoad[a], b.imagesToLoad[a].currentSrc || b.imagesToLoad[a].getAttribute("src"), b.imagesToLoad[a].srcset || b.imagesToLoad[a].getAttribute("srcset"), !0, e);
	      }, b.autoplayTimeoutId = void 0, b.autoplaying = !1, b.autoplayPaused = !1, b.startAutoplay = function () {
	        return "undefined" != typeof b.autoplayTimeoutId ? !1 : b.params.autoplay ? b.autoplaying ? !1 : (b.autoplaying = !0, b.emit("onAutoplayStart", b), void n()) : !1;
	      }, b.stopAutoplay = function (e) {
	        b.autoplayTimeoutId && (b.autoplayTimeoutId && clearTimeout(b.autoplayTimeoutId), b.autoplaying = !1, b.autoplayTimeoutId = void 0, b.emit("onAutoplayStop", b));
	      }, b.pauseAutoplay = function (e) {
	        b.autoplayPaused || (b.autoplayTimeoutId && clearTimeout(b.autoplayTimeoutId), b.autoplayPaused = !0, 0 === e ? (b.autoplayPaused = !1, n()) : b.wrapper.transitionEnd(function () {
	          b && (b.autoplayPaused = !1, b.autoplaying ? n() : b.stopAutoplay());
	        }));
	      }, b.minTranslate = function () {
	        return -b.snapGrid[0];
	      }, b.maxTranslate = function () {
	        return -b.snapGrid[b.snapGrid.length - 1];
	      }, b.updateAutoHeight = function () {
	        var e = b.slides.eq(b.activeIndex)[0];if ("undefined" != typeof e) {
	          var a = e.offsetHeight;a && b.wrapper.css("height", a + "px");
	        }
	      }, b.updateContainerSize = function () {
	        var e, a;e = "undefined" != typeof b.params.width ? b.params.width : b.container[0].clientWidth, a = "undefined" != typeof b.params.height ? b.params.height : b.container[0].clientHeight, 0 === e && b.isHorizontal() || 0 === a && !b.isHorizontal() || (e = e - parseInt(b.container.css("padding-left"), 10) - parseInt(b.container.css("padding-right"), 10), a = a - parseInt(b.container.css("padding-top"), 10) - parseInt(b.container.css("padding-bottom"), 10), b.width = e, b.height = a, b.size = b.isHorizontal() ? b.width : b.height);
	      }, b.updateSlidesSize = function () {
	        b.slides = b.wrapper.children("." + b.params.slideClass), b.snapGrid = [], b.slidesGrid = [], b.slidesSizesGrid = [];var e,
	            a = b.params.spaceBetween,
	            t = -b.params.slidesOffsetBefore,
	            r = 0,
	            i = 0;if ("undefined" != typeof b.size) {
	          "string" == typeof a && a.indexOf("%") >= 0 && (a = parseFloat(a.replace("%", "")) / 100 * b.size), b.virtualSize = -a, b.rtl ? b.slides.css({ marginLeft: "", marginTop: "" }) : b.slides.css({ marginRight: "", marginBottom: "" });var n;b.params.slidesPerColumn > 1 && (n = Math.floor(b.slides.length / b.params.slidesPerColumn) === b.slides.length / b.params.slidesPerColumn ? b.slides.length : Math.ceil(b.slides.length / b.params.slidesPerColumn) * b.params.slidesPerColumn, "auto" !== b.params.slidesPerView && "row" === b.params.slidesPerColumnFill && (n = Math.max(n, b.params.slidesPerView * b.params.slidesPerColumn)));var o,
	              l = b.params.slidesPerColumn,
	              p = n / l,
	              d = p - (b.params.slidesPerColumn * p - b.slides.length);for (e = 0; e < b.slides.length; e++) {
	            o = 0;var u = b.slides.eq(e);if (b.params.slidesPerColumn > 1) {
	              var c, m, h;"column" === b.params.slidesPerColumnFill ? (m = Math.floor(e / l), h = e - m * l, (m > d || m === d && h === l - 1) && ++h >= l && (h = 0, m++), c = m + h * n / l, u.css({ "-webkit-box-ordinal-group": c, "-moz-box-ordinal-group": c, "-ms-flex-order": c, "-webkit-order": c, order: c })) : (h = Math.floor(e / p), m = e - h * p), u.css({ "margin-top": 0 !== h && b.params.spaceBetween && b.params.spaceBetween + "px" }).attr("data-swiper-column", m).attr("data-swiper-row", h);
	            }"none" !== u.css("display") && ("auto" === b.params.slidesPerView ? (o = b.isHorizontal() ? u.outerWidth(!0) : u.outerHeight(!0), b.params.roundLengths && (o = s(o))) : (o = (b.size - (b.params.slidesPerView - 1) * a) / b.params.slidesPerView, b.params.roundLengths && (o = s(o)), b.isHorizontal() ? b.slides[e].style.width = o + "px" : b.slides[e].style.height = o + "px"), b.slides[e].swiperSlideSize = o, b.slidesSizesGrid.push(o), b.params.centeredSlides ? (t = t + o / 2 + r / 2 + a, 0 === e && (t = t - b.size / 2 - a), Math.abs(t) < .001 && (t = 0), i % b.params.slidesPerGroup === 0 && b.snapGrid.push(t), b.slidesGrid.push(t)) : (i % b.params.slidesPerGroup === 0 && b.snapGrid.push(t), b.slidesGrid.push(t), t = t + o + a), b.virtualSize += o + a, r = o, i++);
	          }b.virtualSize = Math.max(b.virtualSize, b.size) + b.params.slidesOffsetAfter;var f;if (b.rtl && b.wrongRTL && ("slide" === b.params.effect || "coverflow" === b.params.effect) && b.wrapper.css({ width: b.virtualSize + b.params.spaceBetween + "px" }), (!b.support.flexbox || b.params.setWrapperSize) && (b.isHorizontal() ? b.wrapper.css({ width: b.virtualSize + b.params.spaceBetween + "px" }) : b.wrapper.css({ height: b.virtualSize + b.params.spaceBetween + "px" })), b.params.slidesPerColumn > 1 && (b.virtualSize = (o + b.params.spaceBetween) * n, b.virtualSize = Math.ceil(b.virtualSize / b.params.slidesPerColumn) - b.params.spaceBetween, b.wrapper.css({ width: b.virtualSize + b.params.spaceBetween + "px" }), b.params.centeredSlides)) {
	            for (f = [], e = 0; e < b.snapGrid.length; e++) b.snapGrid[e] < b.virtualSize + b.snapGrid[0] && f.push(b.snapGrid[e]);b.snapGrid = f;
	          }if (!b.params.centeredSlides) {
	            for (f = [], e = 0; e < b.snapGrid.length; e++) b.snapGrid[e] <= b.virtualSize - b.size && f.push(b.snapGrid[e]);b.snapGrid = f, Math.floor(b.virtualSize - b.size) - Math.floor(b.snapGrid[b.snapGrid.length - 1]) > 1 && b.snapGrid.push(b.virtualSize - b.size);
	          }0 === b.snapGrid.length && (b.snapGrid = [0]), 0 !== b.params.spaceBetween && (b.isHorizontal() ? b.rtl ? b.slides.css({ marginLeft: a + "px" }) : b.slides.css({ marginRight: a + "px" }) : b.slides.css({ marginBottom: a + "px" })), b.params.watchSlidesProgress && b.updateSlidesOffset();
	        }
	      }, b.updateSlidesOffset = function () {
	        for (var e = 0; e < b.slides.length; e++) b.slides[e].swiperSlideOffset = b.isHorizontal() ? b.slides[e].offsetLeft : b.slides[e].offsetTop;
	      }, b.updateSlidesProgress = function (e) {
	        if ("undefined" == typeof e && (e = b.translate || 0), 0 !== b.slides.length) {
	          "undefined" == typeof b.slides[0].swiperSlideOffset && b.updateSlidesOffset();var a = -e;b.rtl && (a = e), b.slides.removeClass(b.params.slideVisibleClass);for (var t = 0; t < b.slides.length; t++) {
	            var r = b.slides[t],
	                i = (a - r.swiperSlideOffset) / (r.swiperSlideSize + b.params.spaceBetween);if (b.params.watchSlidesVisibility) {
	              var s = -(a - r.swiperSlideOffset),
	                  n = s + b.slidesSizesGrid[t],
	                  o = s >= 0 && s < b.size || n > 0 && n <= b.size || 0 >= s && n >= b.size;o && b.slides.eq(t).addClass(b.params.slideVisibleClass);
	            }r.progress = b.rtl ? -i : i;
	          }
	        }
	      }, b.updateProgress = function (e) {
	        "undefined" == typeof e && (e = b.translate || 0);var a = b.maxTranslate() - b.minTranslate(),
	            t = b.isBeginning,
	            r = b.isEnd;0 === a ? (b.progress = 0, b.isBeginning = b.isEnd = !0) : (b.progress = (e - b.minTranslate()) / a, b.isBeginning = b.progress <= 0, b.isEnd = b.progress >= 1), b.isBeginning && !t && b.emit("onReachBeginning", b), b.isEnd && !r && b.emit("onReachEnd", b), b.params.watchSlidesProgress && b.updateSlidesProgress(e), b.emit("onProgress", b, b.progress);
	      }, b.updateActiveIndex = function () {
	        var e,
	            a,
	            t,
	            r = b.rtl ? b.translate : -b.translate;for (a = 0; a < b.slidesGrid.length; a++) "undefined" != typeof b.slidesGrid[a + 1] ? r >= b.slidesGrid[a] && r < b.slidesGrid[a + 1] - (b.slidesGrid[a + 1] - b.slidesGrid[a]) / 2 ? e = a : r >= b.slidesGrid[a] && r < b.slidesGrid[a + 1] && (e = a + 1) : r >= b.slidesGrid[a] && (e = a);(0 > e || "undefined" == typeof e) && (e = 0), t = Math.floor(e / b.params.slidesPerGroup), t >= b.snapGrid.length && (t = b.snapGrid.length - 1), e !== b.activeIndex && (b.snapIndex = t, b.previousIndex = b.activeIndex, b.activeIndex = e, b.updateClasses());
	      }, b.updateClasses = function () {
	        b.slides.removeClass(b.params.slideActiveClass + " " + b.params.slideNextClass + " " + b.params.slidePrevClass);var e = b.slides.eq(b.activeIndex);e.addClass(b.params.slideActiveClass);var t = e.next("." + b.params.slideClass).addClass(b.params.slideNextClass);b.params.loop && 0 === t.length && b.slides.eq(0).addClass(b.params.slideNextClass);var r = e.prev("." + b.params.slideClass).addClass(b.params.slidePrevClass);if (b.params.loop && 0 === r.length && b.slides.eq(-1).addClass(b.params.slidePrevClass), b.paginationContainer && b.paginationContainer.length > 0) {
	          var i,
	              s = b.params.loop ? Math.ceil((b.slides.length - 2 * b.loopedSlides) / b.params.slidesPerGroup) : b.snapGrid.length;if (b.params.loop ? (i = Math.ceil((b.activeIndex - b.loopedSlides) / b.params.slidesPerGroup), i > b.slides.length - 1 - 2 * b.loopedSlides && (i -= b.slides.length - 2 * b.loopedSlides), i > s - 1 && (i -= s), 0 > i && "bullets" !== b.params.paginationType && (i = s + i)) : i = "undefined" != typeof b.snapIndex ? b.snapIndex : b.activeIndex || 0, "bullets" === b.params.paginationType && b.bullets && b.bullets.length > 0 && (b.bullets.removeClass(b.params.bulletActiveClass), b.paginationContainer.length > 1 ? b.bullets.each(function () {
	            a(this).index() === i && a(this).addClass(b.params.bulletActiveClass);
	          }) : b.bullets.eq(i).addClass(b.params.bulletActiveClass)), "fraction" === b.params.paginationType && (b.paginationContainer.find("." + b.params.paginationCurrentClass).text(i + 1), b.paginationContainer.find("." + b.params.paginationTotalClass).text(s)), "progress" === b.params.paginationType) {
	            var n = (i + 1) / s,
	                o = n,
	                l = 1;b.isHorizontal() || (l = n, o = 1), b.paginationContainer.find("." + b.params.paginationProgressbarClass).transform("translate3d(0,0,0) scaleX(" + o + ") scaleY(" + l + ")").transition(b.params.speed);
	          }"custom" === b.params.paginationType && b.params.paginationCustomRender && (b.paginationContainer.html(b.params.paginationCustomRender(b, i + 1, s)), b.emit("onPaginationRendered", b, b.paginationContainer[0]));
	        }b.params.loop || (b.params.prevButton && b.prevButton && b.prevButton.length > 0 && (b.isBeginning ? (b.prevButton.addClass(b.params.buttonDisabledClass), b.params.a11y && b.a11y && b.a11y.disable(b.prevButton)) : (b.prevButton.removeClass(b.params.buttonDisabledClass), b.params.a11y && b.a11y && b.a11y.enable(b.prevButton))), b.params.nextButton && b.nextButton && b.nextButton.length > 0 && (b.isEnd ? (b.nextButton.addClass(b.params.buttonDisabledClass), b.params.a11y && b.a11y && b.a11y.disable(b.nextButton)) : (b.nextButton.removeClass(b.params.buttonDisabledClass), b.params.a11y && b.a11y && b.a11y.enable(b.nextButton))));
	      }, b.updatePagination = function () {
	        if (b.params.pagination && b.paginationContainer && b.paginationContainer.length > 0) {
	          var e = "";if ("bullets" === b.params.paginationType) {
	            for (var a = b.params.loop ? Math.ceil((b.slides.length - 2 * b.loopedSlides) / b.params.slidesPerGroup) : b.snapGrid.length, t = 0; a > t; t++) e += b.params.paginationBulletRender ? b.params.paginationBulletRender(t, b.params.bulletClass) : "<" + b.params.paginationElement + ' class="' + b.params.bulletClass + '"></' + b.params.paginationElement + ">";b.paginationContainer.html(e), b.bullets = b.paginationContainer.find("." + b.params.bulletClass), b.params.paginationClickable && b.params.a11y && b.a11y && b.a11y.initPagination();
	          }"fraction" === b.params.paginationType && (e = b.params.paginationFractionRender ? b.params.paginationFractionRender(b, b.params.paginationCurrentClass, b.params.paginationTotalClass) : '<span class="' + b.params.paginationCurrentClass + '"></span> / <span class="' + b.params.paginationTotalClass + '"></span>', b.paginationContainer.html(e)), "progress" === b.params.paginationType && (e = b.params.paginationProgressRender ? b.params.paginationProgressRender(b, b.params.paginationProgressbarClass) : '<span class="' + b.params.paginationProgressbarClass + '"></span>', b.paginationContainer.html(e)), "custom" !== b.params.paginationType && b.emit("onPaginationRendered", b, b.paginationContainer[0]);
	        }
	      }, b.update = function (e) {
	        function a() {
	          r = Math.min(Math.max(b.translate, b.maxTranslate()), b.minTranslate()), b.setWrapperTranslate(r), b.updateActiveIndex(), b.updateClasses();
	        }if (b.updateContainerSize(), b.updateSlidesSize(), b.updateProgress(), b.updatePagination(), b.updateClasses(), b.params.scrollbar && b.scrollbar && b.scrollbar.set(), e) {
	          var t, r;b.controller && b.controller.spline && (b.controller.spline = void 0), b.params.freeMode ? (a(), b.params.autoHeight && b.updateAutoHeight()) : (t = ("auto" === b.params.slidesPerView || b.params.slidesPerView > 1) && b.isEnd && !b.params.centeredSlides ? b.slideTo(b.slides.length - 1, 0, !1, !0) : b.slideTo(b.activeIndex, 0, !1, !0), t || a());
	        } else b.params.autoHeight && b.updateAutoHeight();
	      }, b.onResize = function (e) {
	        b.params.breakpoints && b.setBreakpoint();var a = b.params.allowSwipeToPrev,
	            t = b.params.allowSwipeToNext;b.params.allowSwipeToPrev = b.params.allowSwipeToNext = !0, b.updateContainerSize(), b.updateSlidesSize(), ("auto" === b.params.slidesPerView || b.params.freeMode || e) && b.updatePagination(), b.params.scrollbar && b.scrollbar && b.scrollbar.set(), b.controller && b.controller.spline && (b.controller.spline = void 0);var r = !1;if (b.params.freeMode) {
	          var i = Math.min(Math.max(b.translate, b.maxTranslate()), b.minTranslate());b.setWrapperTranslate(i), b.updateActiveIndex(), b.updateClasses(), b.params.autoHeight && b.updateAutoHeight();
	        } else b.updateClasses(), r = ("auto" === b.params.slidesPerView || b.params.slidesPerView > 1) && b.isEnd && !b.params.centeredSlides ? b.slideTo(b.slides.length - 1, 0, !1, !0) : b.slideTo(b.activeIndex, 0, !1, !0);b.params.lazyLoading && !r && b.lazy && b.lazy.load(), b.params.allowSwipeToPrev = a, b.params.allowSwipeToNext = t;
	      };var T = ["mousedown", "mousemove", "mouseup"];window.navigator.pointerEnabled ? T = ["pointerdown", "pointermove", "pointerup"] : window.navigator.msPointerEnabled && (T = ["MSPointerDown", "MSPointerMove", "MSPointerUp"]), b.touchEvents = { start: b.support.touch || !b.params.simulateTouch ? "touchstart" : T[0], move: b.support.touch || !b.params.simulateTouch ? "touchmove" : T[1], end: b.support.touch || !b.params.simulateTouch ? "touchend" : T[2] }, (window.navigator.pointerEnabled || window.navigator.msPointerEnabled) && ("container" === b.params.touchEventsTarget ? b.container : b.wrapper).addClass("swiper-wp8-" + b.params.direction), b.initEvents = function (e) {
	        var a = e ? "off" : "on",
	            t = e ? "removeEventListener" : "addEventListener",
	            r = "container" === b.params.touchEventsTarget ? b.container[0] : b.wrapper[0],
	            s = b.support.touch ? r : document,
	            n = b.params.nested ? !0 : !1;b.browser.ie ? (r[t](b.touchEvents.start, b.onTouchStart, !1), s[t](b.touchEvents.move, b.onTouchMove, n), s[t](b.touchEvents.end, b.onTouchEnd, !1)) : (b.support.touch && (r[t](b.touchEvents.start, b.onTouchStart, !1), r[t](b.touchEvents.move, b.onTouchMove, n), r[t](b.touchEvents.end, b.onTouchEnd, !1)), !i.simulateTouch || b.device.ios || b.device.android || (r[t]("mousedown", b.onTouchStart, !1), document[t]("mousemove", b.onTouchMove, n), document[t]("mouseup", b.onTouchEnd, !1))), window[t]("resize", b.onResize), b.params.nextButton && b.nextButton && b.nextButton.length > 0 && (b.nextButton[a]("click", b.onClickNext), b.params.a11y && b.a11y && b.nextButton[a]("keydown", b.a11y.onEnterKey)), b.params.prevButton && b.prevButton && b.prevButton.length > 0 && (b.prevButton[a]("click", b.onClickPrev), b.params.a11y && b.a11y && b.prevButton[a]("keydown", b.a11y.onEnterKey)), b.params.pagination && b.params.paginationClickable && (b.paginationContainer[a]("click", "." + b.params.bulletClass, b.onClickIndex), b.params.a11y && b.a11y && b.paginationContainer[a]("keydown", "." + b.params.bulletClass, b.a11y.onEnterKey)), (b.params.preventClicks || b.params.preventClicksPropagation) && r[t]("click", b.preventClicks, !0);
	      }, b.attachEvents = function () {
	        b.initEvents();
	      }, b.detachEvents = function () {
	        b.initEvents(!0);
	      }, b.allowClick = !0, b.preventClicks = function (e) {
	        b.allowClick || (b.params.preventClicks && e.preventDefault(), b.params.preventClicksPropagation && b.animating && (e.stopPropagation(), e.stopImmediatePropagation()));
	      }, b.onClickNext = function (e) {
	        e.preventDefault(), (!b.isEnd || b.params.loop) && b.slideNext();
	      }, b.onClickPrev = function (e) {
	        e.preventDefault(), (!b.isBeginning || b.params.loop) && b.slidePrev();
	      }, b.onClickIndex = function (e) {
	        e.preventDefault();var t = a(this).index() * b.params.slidesPerGroup;b.params.loop && (t += b.loopedSlides), b.slideTo(t);
	      }, b.updateClickedSlide = function (e) {
	        var t = o(e, "." + b.params.slideClass),
	            r = !1;if (t) for (var i = 0; i < b.slides.length; i++) b.slides[i] === t && (r = !0);if (!t || !r) return b.clickedSlide = void 0, void (b.clickedIndex = void 0);if (b.clickedSlide = t, b.clickedIndex = a(t).index(), b.params.slideToClickedSlide && void 0 !== b.clickedIndex && b.clickedIndex !== b.activeIndex) {
	          var s,
	              n = b.clickedIndex;if (b.params.loop) {
	            if (b.animating) return;s = a(b.clickedSlide).attr("data-swiper-slide-index"), b.params.centeredSlides ? n < b.loopedSlides - b.params.slidesPerView / 2 || n > b.slides.length - b.loopedSlides + b.params.slidesPerView / 2 ? (b.fixLoop(), n = b.wrapper.children("." + b.params.slideClass + '[data-swiper-slide-index="' + s + '"]:not(.swiper-slide-duplicate)').eq(0).index(), setTimeout(function () {
	              b.slideTo(n);
	            }, 0)) : b.slideTo(n) : n > b.slides.length - b.params.slidesPerView ? (b.fixLoop(), n = b.wrapper.children("." + b.params.slideClass + '[data-swiper-slide-index="' + s + '"]:not(.swiper-slide-duplicate)').eq(0).index(), setTimeout(function () {
	              b.slideTo(n);
	            }, 0)) : b.slideTo(n);
	          } else b.slideTo(n);
	        }
	      };var S,
	          C,
	          z,
	          M,
	          E,
	          P,
	          k,
	          I,
	          L,
	          B,
	          D = "input, select, textarea, button",
	          H = Date.now(),
	          A = [];b.animating = !1, b.touches = { startX: 0, startY: 0, currentX: 0, currentY: 0, diff: 0 };var G, O;if (b.onTouchStart = function (e) {
	        if (e.originalEvent && (e = e.originalEvent), G = "touchstart" === e.type, G || !("which" in e) || 3 !== e.which) {
	          if (b.params.noSwiping && o(e, "." + b.params.noSwipingClass)) return void (b.allowClick = !0);if (!b.params.swipeHandler || o(e, b.params.swipeHandler)) {
	            var t = b.touches.currentX = "touchstart" === e.type ? e.targetTouches[0].pageX : e.pageX,
	                r = b.touches.currentY = "touchstart" === e.type ? e.targetTouches[0].pageY : e.pageY;if (!(b.device.ios && b.params.iOSEdgeSwipeDetection && t <= b.params.iOSEdgeSwipeThreshold)) {
	              if (S = !0, C = !1, z = !0, E = void 0, O = void 0, b.touches.startX = t, b.touches.startY = r, M = Date.now(), b.allowClick = !0, b.updateContainerSize(), b.swipeDirection = void 0, b.params.threshold > 0 && (I = !1), "touchstart" !== e.type) {
	                var i = !0;a(e.target).is(D) && (i = !1), document.activeElement && a(document.activeElement).is(D) && document.activeElement.blur(), i && e.preventDefault();
	              }b.emit("onTouchStart", b, e);
	            }
	          }
	        }
	      }, b.onTouchMove = function (e) {
	        if (e.originalEvent && (e = e.originalEvent), !G || "mousemove" !== e.type) {
	          if (e.preventedByNestedSwiper) return b.touches.startX = "touchmove" === e.type ? e.targetTouches[0].pageX : e.pageX, void (b.touches.startY = "touchmove" === e.type ? e.targetTouches[0].pageY : e.pageY);if (b.params.onlyExternal) return b.allowClick = !1, void (S && (b.touches.startX = b.touches.currentX = "touchmove" === e.type ? e.targetTouches[0].pageX : e.pageX, b.touches.startY = b.touches.currentY = "touchmove" === e.type ? e.targetTouches[0].pageY : e.pageY, M = Date.now()));if (G && document.activeElement && e.target === document.activeElement && a(e.target).is(D)) return C = !0, void (b.allowClick = !1);if (z && b.emit("onTouchMove", b, e), !(e.targetTouches && e.targetTouches.length > 1)) {
	            if (b.touches.currentX = "touchmove" === e.type ? e.targetTouches[0].pageX : e.pageX, b.touches.currentY = "touchmove" === e.type ? e.targetTouches[0].pageY : e.pageY, "undefined" == typeof E) {
	              var t = 180 * Math.atan2(Math.abs(b.touches.currentY - b.touches.startY), Math.abs(b.touches.currentX - b.touches.startX)) / Math.PI;E = b.isHorizontal() ? t > b.params.touchAngle : 90 - t > b.params.touchAngle;
	            }if (E && b.emit("onTouchMoveOpposite", b, e), "undefined" == typeof O && b.browser.ieTouch && (b.touches.currentX !== b.touches.startX || b.touches.currentY !== b.touches.startY) && (O = !0), S) {
	              if (E) return void (S = !1);if (O || !b.browser.ieTouch) {
	                b.allowClick = !1, b.emit("onSliderMove", b, e), e.preventDefault(), b.params.touchMoveStopPropagation && !b.params.nested && e.stopPropagation(), C || (i.loop && b.fixLoop(), k = b.getWrapperTranslate(), b.setWrapperTransition(0), b.animating && b.wrapper.trigger("webkitTransitionEnd transitionend oTransitionEnd MSTransitionEnd msTransitionEnd"), b.params.autoplay && b.autoplaying && (b.params.autoplayDisableOnInteraction ? b.stopAutoplay() : b.pauseAutoplay()), B = !1, b.params.grabCursor && (b.container[0].style.cursor = "move", b.container[0].style.cursor = "-webkit-grabbing", b.container[0].style.cursor = "-moz-grabbin", b.container[0].style.cursor = "grabbing")), C = !0;var r = b.touches.diff = b.isHorizontal() ? b.touches.currentX - b.touches.startX : b.touches.currentY - b.touches.startY;r *= b.params.touchRatio, b.rtl && (r = -r), b.swipeDirection = r > 0 ? "prev" : "next", P = r + k;var s = !0;if (r > 0 && P > b.minTranslate() ? (s = !1, b.params.resistance && (P = b.minTranslate() - 1 + Math.pow(-b.minTranslate() + k + r, b.params.resistanceRatio))) : 0 > r && P < b.maxTranslate() && (s = !1, b.params.resistance && (P = b.maxTranslate() + 1 - Math.pow(b.maxTranslate() - k - r, b.params.resistanceRatio))), s && (e.preventedByNestedSwiper = !0), !b.params.allowSwipeToNext && "next" === b.swipeDirection && k > P && (P = k), !b.params.allowSwipeToPrev && "prev" === b.swipeDirection && P > k && (P = k), b.params.followFinger) {
	                  if (b.params.threshold > 0) {
	                    if (!(Math.abs(r) > b.params.threshold || I)) return void (P = k);if (!I) return I = !0, b.touches.startX = b.touches.currentX, b.touches.startY = b.touches.currentY, P = k, void (b.touches.diff = b.isHorizontal() ? b.touches.currentX - b.touches.startX : b.touches.currentY - b.touches.startY);
	                  }(b.params.freeMode || b.params.watchSlidesProgress) && b.updateActiveIndex(), b.params.freeMode && (0 === A.length && A.push({ position: b.touches[b.isHorizontal() ? "startX" : "startY"], time: M }), A.push({ position: b.touches[b.isHorizontal() ? "currentX" : "currentY"], time: new window.Date().getTime() })), b.updateProgress(P), b.setWrapperTranslate(P);
	                }
	              }
	            }
	          }
	        }
	      }, b.onTouchEnd = function (e) {
	        if (e.originalEvent && (e = e.originalEvent), z && b.emit("onTouchEnd", b, e), z = !1, S) {
	          b.params.grabCursor && C && S && (b.container[0].style.cursor = "move", b.container[0].style.cursor = "-webkit-grab", b.container[0].style.cursor = "-moz-grab", b.container[0].style.cursor = "grab");var t = Date.now(),
	              r = t - M;if (b.allowClick && (b.updateClickedSlide(e), b.emit("onTap", b, e), 300 > r && t - H > 300 && (L && clearTimeout(L), L = setTimeout(function () {
	            b && (b.params.paginationHide && b.paginationContainer.length > 0 && !a(e.target).hasClass(b.params.bulletClass) && b.paginationContainer.toggleClass(b.params.paginationHiddenClass), b.emit("onClick", b, e));
	          }, 300)), 300 > r && 300 > t - H && (L && clearTimeout(L), b.emit("onDoubleTap", b, e))), H = Date.now(), setTimeout(function () {
	            b && (b.allowClick = !0);
	          }, 0), !S || !C || !b.swipeDirection || 0 === b.touches.diff || P === k) return void (S = C = !1);S = C = !1;var i;if (i = b.params.followFinger ? b.rtl ? b.translate : -b.translate : -P, b.params.freeMode) {
	            if (i < -b.minTranslate()) return void b.slideTo(b.activeIndex);if (i > -b.maxTranslate()) return void (b.slides.length < b.snapGrid.length ? b.slideTo(b.snapGrid.length - 1) : b.slideTo(b.slides.length - 1));if (b.params.freeModeMomentum) {
	              if (A.length > 1) {
	                var s = A.pop(),
	                    n = A.pop(),
	                    o = s.position - n.position,
	                    l = s.time - n.time;b.velocity = o / l, b.velocity = b.velocity / 2, Math.abs(b.velocity) < b.params.freeModeMinimumVelocity && (b.velocity = 0), (l > 150 || new window.Date().getTime() - s.time > 300) && (b.velocity = 0);
	              } else b.velocity = 0;A.length = 0;var p = 1e3 * b.params.freeModeMomentumRatio,
	                  d = b.velocity * p,
	                  u = b.translate + d;b.rtl && (u = -u);var c,
	                  m = !1,
	                  h = 20 * Math.abs(b.velocity) * b.params.freeModeMomentumBounceRatio;if (u < b.maxTranslate()) b.params.freeModeMomentumBounce ? (u + b.maxTranslate() < -h && (u = b.maxTranslate() - h), c = b.maxTranslate(), m = !0, B = !0) : u = b.maxTranslate();else if (u > b.minTranslate()) b.params.freeModeMomentumBounce ? (u - b.minTranslate() > h && (u = b.minTranslate() + h), c = b.minTranslate(), m = !0, B = !0) : u = b.minTranslate();else if (b.params.freeModeSticky) {
	                var f,
	                    g = 0;for (g = 0; g < b.snapGrid.length; g += 1) if (b.snapGrid[g] > -u) {
	                  f = g;break;
	                }u = Math.abs(b.snapGrid[f] - u) < Math.abs(b.snapGrid[f - 1] - u) || "next" === b.swipeDirection ? b.snapGrid[f] : b.snapGrid[f - 1], b.rtl || (u = -u);
	              }if (0 !== b.velocity) p = b.rtl ? Math.abs((-u - b.translate) / b.velocity) : Math.abs((u - b.translate) / b.velocity);else if (b.params.freeModeSticky) return void b.slideReset();b.params.freeModeMomentumBounce && m ? (b.updateProgress(c), b.setWrapperTransition(p), b.setWrapperTranslate(u), b.onTransitionStart(), b.animating = !0, b.wrapper.transitionEnd(function () {
	                b && B && (b.emit("onMomentumBounce", b), b.setWrapperTransition(b.params.speed), b.setWrapperTranslate(c), b.wrapper.transitionEnd(function () {
	                  b && b.onTransitionEnd();
	                }));
	              })) : b.velocity ? (b.updateProgress(u), b.setWrapperTransition(p), b.setWrapperTranslate(u), b.onTransitionStart(), b.animating || (b.animating = !0, b.wrapper.transitionEnd(function () {
	                b && b.onTransitionEnd();
	              }))) : b.updateProgress(u), b.updateActiveIndex();
	            }return void ((!b.params.freeModeMomentum || r >= b.params.longSwipesMs) && (b.updateProgress(), b.updateActiveIndex()));
	          }var v,
	              w = 0,
	              y = b.slidesSizesGrid[0];for (v = 0; v < b.slidesGrid.length; v += b.params.slidesPerGroup) "undefined" != typeof b.slidesGrid[v + b.params.slidesPerGroup] ? i >= b.slidesGrid[v] && i < b.slidesGrid[v + b.params.slidesPerGroup] && (w = v, y = b.slidesGrid[v + b.params.slidesPerGroup] - b.slidesGrid[v]) : i >= b.slidesGrid[v] && (w = v, y = b.slidesGrid[b.slidesGrid.length - 1] - b.slidesGrid[b.slidesGrid.length - 2]);var x = (i - b.slidesGrid[w]) / y;if (r > b.params.longSwipesMs) {
	            if (!b.params.longSwipes) return void b.slideTo(b.activeIndex);"next" === b.swipeDirection && (x >= b.params.longSwipesRatio ? b.slideTo(w + b.params.slidesPerGroup) : b.slideTo(w)), "prev" === b.swipeDirection && (x > 1 - b.params.longSwipesRatio ? b.slideTo(w + b.params.slidesPerGroup) : b.slideTo(w));
	          } else {
	            if (!b.params.shortSwipes) return void b.slideTo(b.activeIndex);"next" === b.swipeDirection && b.slideTo(w + b.params.slidesPerGroup), "prev" === b.swipeDirection && b.slideTo(w);
	          }
	        }
	      }, b._slideTo = function (e, a) {
	        return b.slideTo(e, a, !0, !0);
	      }, b.slideTo = function (e, a, t, r) {
	        "undefined" == typeof t && (t = !0), "undefined" == typeof e && (e = 0), 0 > e && (e = 0), b.snapIndex = Math.floor(e / b.params.slidesPerGroup), b.snapIndex >= b.snapGrid.length && (b.snapIndex = b.snapGrid.length - 1);var i = -b.snapGrid[b.snapIndex];b.params.autoplay && b.autoplaying && (r || !b.params.autoplayDisableOnInteraction ? b.pauseAutoplay(a) : b.stopAutoplay()), b.updateProgress(i);for (var s = 0; s < b.slidesGrid.length; s++) -Math.floor(100 * i) >= Math.floor(100 * b.slidesGrid[s]) && (e = s);return !b.params.allowSwipeToNext && i < b.translate && i < b.minTranslate() ? !1 : !b.params.allowSwipeToPrev && i > b.translate && i > b.maxTranslate() && (b.activeIndex || 0) !== e ? !1 : ("undefined" == typeof a && (a = b.params.speed), b.previousIndex = b.activeIndex || 0, b.activeIndex = e, b.rtl && -i === b.translate || !b.rtl && i === b.translate ? (b.params.autoHeight && b.updateAutoHeight(), b.updateClasses(), "slide" !== b.params.effect && b.setWrapperTranslate(i), !1) : (b.updateClasses(), b.onTransitionStart(t), 0 === a ? (b.setWrapperTranslate(i), b.setWrapperTransition(0), b.onTransitionEnd(t)) : (b.setWrapperTranslate(i), b.setWrapperTransition(a), b.animating || (b.animating = !0, b.wrapper.transitionEnd(function () {
	          b && b.onTransitionEnd(t);
	        }))), !0));
	      }, b.onTransitionStart = function (e) {
	        "undefined" == typeof e && (e = !0), b.params.autoHeight && b.updateAutoHeight(), b.lazy && b.lazy.onTransitionStart(), e && (b.emit("onTransitionStart", b), b.activeIndex !== b.previousIndex && (b.emit("onSlideChangeStart", b), b.activeIndex > b.previousIndex ? b.emit("onSlideNextStart", b) : b.emit("onSlidePrevStart", b)));
	      }, b.onTransitionEnd = function (e) {
	        b.animating = !1, b.setWrapperTransition(0), "undefined" == typeof e && (e = !0), b.lazy && b.lazy.onTransitionEnd(), e && (b.emit("onTransitionEnd", b), b.activeIndex !== b.previousIndex && (b.emit("onSlideChangeEnd", b), b.activeIndex > b.previousIndex ? b.emit("onSlideNextEnd", b) : b.emit("onSlidePrevEnd", b))), b.params.hashnav && b.hashnav && b.hashnav.setHash();
	      }, b.slideNext = function (e, a, t) {
	        if (b.params.loop) {
	          if (b.animating) return !1;b.fixLoop();b.container[0].clientLeft;return b.slideTo(b.activeIndex + b.params.slidesPerGroup, a, e, t);
	        }return b.slideTo(b.activeIndex + b.params.slidesPerGroup, a, e, t);
	      }, b._slideNext = function (e) {
	        return b.slideNext(!0, e, !0);
	      }, b.slidePrev = function (e, a, t) {
	        if (b.params.loop) {
	          if (b.animating) return !1;b.fixLoop();b.container[0].clientLeft;return b.slideTo(b.activeIndex - 1, a, e, t);
	        }return b.slideTo(b.activeIndex - 1, a, e, t);
	      }, b._slidePrev = function (e) {
	        return b.slidePrev(!0, e, !0);
	      }, b.slideReset = function (e, a, t) {
	        return b.slideTo(b.activeIndex, a, e);
	      }, b.setWrapperTransition = function (e, a) {
	        b.wrapper.transition(e), "slide" !== b.params.effect && b.effects[b.params.effect] && b.effects[b.params.effect].setTransition(e), b.params.parallax && b.parallax && b.parallax.setTransition(e), b.params.scrollbar && b.scrollbar && b.scrollbar.setTransition(e), b.params.control && b.controller && b.controller.setTransition(e, a), b.emit("onSetTransition", b, e);
	      }, b.setWrapperTranslate = function (e, a, t) {
	        var r = 0,
	            i = 0,
	            n = 0;b.isHorizontal() ? r = b.rtl ? -e : e : i = e, b.params.roundLengths && (r = s(r), i = s(i)), b.params.virtualTranslate || (b.support.transforms3d ? b.wrapper.transform("translate3d(" + r + "px, " + i + "px, " + n + "px)") : b.wrapper.transform("translate(" + r + "px, " + i + "px)")), b.translate = b.isHorizontal() ? r : i;var o,
	            l = b.maxTranslate() - b.minTranslate();o = 0 === l ? 0 : (e - b.minTranslate()) / l, o !== b.progress && b.updateProgress(e), a && b.updateActiveIndex(), "slide" !== b.params.effect && b.effects[b.params.effect] && b.effects[b.params.effect].setTranslate(b.translate), b.params.parallax && b.parallax && b.parallax.setTranslate(b.translate), b.params.scrollbar && b.scrollbar && b.scrollbar.setTranslate(b.translate), b.params.control && b.controller && b.controller.setTranslate(b.translate, t), b.emit("onSetTranslate", b, b.translate);
	      }, b.getTranslate = function (e, a) {
	        var t, r, i, s;return "undefined" == typeof a && (a = "x"), b.params.virtualTranslate ? b.rtl ? -b.translate : b.translate : (i = window.getComputedStyle(e, null), window.WebKitCSSMatrix ? (r = i.transform || i.webkitTransform, r.split(",").length > 6 && (r = r.split(", ").map(function (e) {
	          return e.replace(",", ".");
	        }).join(", ")), s = new window.WebKitCSSMatrix("none" === r ? "" : r)) : (s = i.MozTransform || i.OTransform || i.MsTransform || i.msTransform || i.transform || i.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,"), t = s.toString().split(",")), "x" === a && (r = window.WebKitCSSMatrix ? s.m41 : 16 === t.length ? parseFloat(t[12]) : parseFloat(t[4])), "y" === a && (r = window.WebKitCSSMatrix ? s.m42 : 16 === t.length ? parseFloat(t[13]) : parseFloat(t[5])), b.rtl && r && (r = -r), r || 0);
	      }, b.getWrapperTranslate = function (e) {
	        return "undefined" == typeof e && (e = b.isHorizontal() ? "x" : "y"), b.getTranslate(b.wrapper[0], e);
	      }, b.observers = [], b.initObservers = function () {
	        if (b.params.observeParents) for (var e = b.container.parents(), a = 0; a < e.length; a++) l(e[a]);l(b.container[0], { childList: !1 }), l(b.wrapper[0], { attributes: !1 });
	      }, b.disconnectObservers = function () {
	        for (var e = 0; e < b.observers.length; e++) b.observers[e].disconnect();b.observers = [];
	      }, b.createLoop = function () {
	        b.wrapper.children("." + b.params.slideClass + "." + b.params.slideDuplicateClass).remove();var e = b.wrapper.children("." + b.params.slideClass);"auto" !== b.params.slidesPerView || b.params.loopedSlides || (b.params.loopedSlides = e.length), b.loopedSlides = parseInt(b.params.loopedSlides || b.params.slidesPerView, 10), b.loopedSlides = b.loopedSlides + b.params.loopAdditionalSlides, b.loopedSlides > e.length && (b.loopedSlides = e.length);var t,
	            r = [],
	            i = [];for (e.each(function (t, s) {
	          var n = a(this);t < b.loopedSlides && i.push(s), t < e.length && t >= e.length - b.loopedSlides && r.push(s), n.attr("data-swiper-slide-index", t);
	        }), t = 0; t < i.length; t++) b.wrapper.append(a(i[t].cloneNode(!0)).addClass(b.params.slideDuplicateClass));for (t = r.length - 1; t >= 0; t--) b.wrapper.prepend(a(r[t].cloneNode(!0)).addClass(b.params.slideDuplicateClass));
	      }, b.destroyLoop = function () {
	        b.wrapper.children("." + b.params.slideClass + "." + b.params.slideDuplicateClass).remove(), b.slides.removeAttr("data-swiper-slide-index");
	      }, b.reLoop = function (e) {
	        var a = b.activeIndex - b.loopedSlides;b.destroyLoop(), b.createLoop(), b.updateSlidesSize(), e && b.slideTo(a + b.loopedSlides, 0, !1);
	      }, b.fixLoop = function () {
	        var e;b.activeIndex < b.loopedSlides ? (e = b.slides.length - 3 * b.loopedSlides + b.activeIndex, e += b.loopedSlides, b.slideTo(e, 0, !1, !0)) : ("auto" === b.params.slidesPerView && b.activeIndex >= 2 * b.loopedSlides || b.activeIndex > b.slides.length - 2 * b.params.slidesPerView) && (e = -b.slides.length + b.activeIndex + b.loopedSlides, e += b.loopedSlides, b.slideTo(e, 0, !1, !0));
	      }, b.appendSlide = function (e) {
	        if (b.params.loop && b.destroyLoop(), "object" == typeof e && e.length) for (var a = 0; a < e.length; a++) e[a] && b.wrapper.append(e[a]);else b.wrapper.append(e);b.params.loop && b.createLoop(), b.params.observer && b.support.observer || b.update(!0);
	      }, b.prependSlide = function (e) {
	        b.params.loop && b.destroyLoop();var a = b.activeIndex + 1;if ("object" == typeof e && e.length) {
	          for (var t = 0; t < e.length; t++) e[t] && b.wrapper.prepend(e[t]);a = b.activeIndex + e.length;
	        } else b.wrapper.prepend(e);b.params.loop && b.createLoop(), b.params.observer && b.support.observer || b.update(!0), b.slideTo(a, 0, !1);
	      }, b.removeSlide = function (e) {
	        b.params.loop && (b.destroyLoop(), b.slides = b.wrapper.children("." + b.params.slideClass));var a,
	            t = b.activeIndex;if ("object" == typeof e && e.length) {
	          for (var r = 0; r < e.length; r++) a = e[r], b.slides[a] && b.slides.eq(a).remove(), t > a && t--;t = Math.max(t, 0);
	        } else a = e, b.slides[a] && b.slides.eq(a).remove(), t > a && t--, t = Math.max(t, 0);b.params.loop && b.createLoop(), b.params.observer && b.support.observer || b.update(!0), b.params.loop ? b.slideTo(t + b.loopedSlides, 0, !1) : b.slideTo(t, 0, !1);
	      }, b.removeAllSlides = function () {
	        for (var e = [], a = 0; a < b.slides.length; a++) e.push(a);b.removeSlide(e);
	      }, b.effects = { fade: { setTranslate: function () {
	            for (var e = 0; e < b.slides.length; e++) {
	              var a = b.slides.eq(e),
	                  t = a[0].swiperSlideOffset,
	                  r = -t;b.params.virtualTranslate || (r -= b.translate);var i = 0;b.isHorizontal() || (i = r, r = 0);var s = b.params.fade.crossFade ? Math.max(1 - Math.abs(a[0].progress), 0) : 1 + Math.min(Math.max(a[0].progress, -1), 0);a.css({ opacity: s }).transform("translate3d(" + r + "px, " + i + "px, 0px)");
	            }
	          }, setTransition: function (e) {
	            if (b.slides.transition(e), b.params.virtualTranslate && 0 !== e) {
	              var a = !1;b.slides.transitionEnd(function () {
	                if (!a && b) {
	                  a = !0, b.animating = !1;for (var e = ["webkitTransitionEnd", "transitionend", "oTransitionEnd", "MSTransitionEnd", "msTransitionEnd"], t = 0; t < e.length; t++) b.wrapper.trigger(e[t]);
	                }
	              });
	            }
	          } }, flip: { setTranslate: function () {
	            for (var e = 0; e < b.slides.length; e++) {
	              var t = b.slides.eq(e),
	                  r = t[0].progress;b.params.flip.limitRotation && (r = Math.max(Math.min(t[0].progress, 1), -1));var i = t[0].swiperSlideOffset,
	                  s = -180 * r,
	                  n = s,
	                  o = 0,
	                  l = -i,
	                  p = 0;if (b.isHorizontal() ? b.rtl && (n = -n) : (p = l, l = 0, o = -n, n = 0), t[0].style.zIndex = -Math.abs(Math.round(r)) + b.slides.length, b.params.flip.slideShadows) {
	                var d = b.isHorizontal() ? t.find(".swiper-slide-shadow-left") : t.find(".swiper-slide-shadow-top"),
	                    u = b.isHorizontal() ? t.find(".swiper-slide-shadow-right") : t.find(".swiper-slide-shadow-bottom");0 === d.length && (d = a('<div class="swiper-slide-shadow-' + (b.isHorizontal() ? "left" : "top") + '"></div>'), t.append(d)), 0 === u.length && (u = a('<div class="swiper-slide-shadow-' + (b.isHorizontal() ? "right" : "bottom") + '"></div>'), t.append(u)), d.length && (d[0].style.opacity = Math.max(-r, 0)), u.length && (u[0].style.opacity = Math.max(r, 0));
	              }t.transform("translate3d(" + l + "px, " + p + "px, 0px) rotateX(" + o + "deg) rotateY(" + n + "deg)");
	            }
	          }, setTransition: function (e) {
	            if (b.slides.transition(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(e), b.params.virtualTranslate && 0 !== e) {
	              var t = !1;b.slides.eq(b.activeIndex).transitionEnd(function () {
	                if (!t && b && a(this).hasClass(b.params.slideActiveClass)) {
	                  t = !0, b.animating = !1;for (var e = ["webkitTransitionEnd", "transitionend", "oTransitionEnd", "MSTransitionEnd", "msTransitionEnd"], r = 0; r < e.length; r++) b.wrapper.trigger(e[r]);
	                }
	              });
	            }
	          } }, cube: { setTranslate: function () {
	            var e,
	                t = 0;b.params.cube.shadow && (b.isHorizontal() ? (e = b.wrapper.find(".swiper-cube-shadow"), 0 === e.length && (e = a('<div class="swiper-cube-shadow"></div>'), b.wrapper.append(e)), e.css({ height: b.width + "px" })) : (e = b.container.find(".swiper-cube-shadow"), 0 === e.length && (e = a('<div class="swiper-cube-shadow"></div>'), b.container.append(e))));for (var r = 0; r < b.slides.length; r++) {
	              var i = b.slides.eq(r),
	                  s = 90 * r,
	                  n = Math.floor(s / 360);b.rtl && (s = -s, n = Math.floor(-s / 360));var o = Math.max(Math.min(i[0].progress, 1), -1),
	                  l = 0,
	                  p = 0,
	                  d = 0;r % 4 === 0 ? (l = 4 * -n * b.size, d = 0) : (r - 1) % 4 === 0 ? (l = 0, d = 4 * -n * b.size) : (r - 2) % 4 === 0 ? (l = b.size + 4 * n * b.size, d = b.size) : (r - 3) % 4 === 0 && (l = -b.size, d = 3 * b.size + 4 * b.size * n), b.rtl && (l = -l), b.isHorizontal() || (p = l, l = 0);var u = "rotateX(" + (b.isHorizontal() ? 0 : -s) + "deg) rotateY(" + (b.isHorizontal() ? s : 0) + "deg) translate3d(" + l + "px, " + p + "px, " + d + "px)";if (1 >= o && o > -1 && (t = 90 * r + 90 * o, b.rtl && (t = 90 * -r - 90 * o)), i.transform(u), b.params.cube.slideShadows) {
	                var c = b.isHorizontal() ? i.find(".swiper-slide-shadow-left") : i.find(".swiper-slide-shadow-top"),
	                    m = b.isHorizontal() ? i.find(".swiper-slide-shadow-right") : i.find(".swiper-slide-shadow-bottom");0 === c.length && (c = a('<div class="swiper-slide-shadow-' + (b.isHorizontal() ? "left" : "top") + '"></div>'), i.append(c)), 0 === m.length && (m = a('<div class="swiper-slide-shadow-' + (b.isHorizontal() ? "right" : "bottom") + '"></div>'), i.append(m)), c.length && (c[0].style.opacity = Math.max(-o, 0)), m.length && (m[0].style.opacity = Math.max(o, 0));
	              }
	            }if (b.wrapper.css({ "-webkit-transform-origin": "50% 50% -" + b.size / 2 + "px", "-moz-transform-origin": "50% 50% -" + b.size / 2 + "px", "-ms-transform-origin": "50% 50% -" + b.size / 2 + "px", "transform-origin": "50% 50% -" + b.size / 2 + "px" }), b.params.cube.shadow) if (b.isHorizontal()) e.transform("translate3d(0px, " + (b.width / 2 + b.params.cube.shadowOffset) + "px, " + -b.width / 2 + "px) rotateX(90deg) rotateZ(0deg) scale(" + b.params.cube.shadowScale + ")");else {
	              var h = Math.abs(t) - 90 * Math.floor(Math.abs(t) / 90),
	                  f = 1.5 - (Math.sin(2 * h * Math.PI / 360) / 2 + Math.cos(2 * h * Math.PI / 360) / 2),
	                  g = b.params.cube.shadowScale,
	                  v = b.params.cube.shadowScale / f,
	                  w = b.params.cube.shadowOffset;e.transform("scale3d(" + g + ", 1, " + v + ") translate3d(0px, " + (b.height / 2 + w) + "px, " + -b.height / 2 / v + "px) rotateX(-90deg)");
	            }var y = b.isSafari || b.isUiWebView ? -b.size / 2 : 0;b.wrapper.transform("translate3d(0px,0," + y + "px) rotateX(" + (b.isHorizontal() ? 0 : t) + "deg) rotateY(" + (b.isHorizontal() ? -t : 0) + "deg)");
	          }, setTransition: function (e) {
	            b.slides.transition(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(e), b.params.cube.shadow && !b.isHorizontal() && b.container.find(".swiper-cube-shadow").transition(e);
	          } }, coverflow: { setTranslate: function () {
	            for (var e = b.translate, t = b.isHorizontal() ? -e + b.width / 2 : -e + b.height / 2, r = b.isHorizontal() ? b.params.coverflow.rotate : -b.params.coverflow.rotate, i = b.params.coverflow.depth, s = 0, n = b.slides.length; n > s; s++) {
	              var o = b.slides.eq(s),
	                  l = b.slidesSizesGrid[s],
	                  p = o[0].swiperSlideOffset,
	                  d = (t - p - l / 2) / l * b.params.coverflow.modifier,
	                  u = b.isHorizontal() ? r * d : 0,
	                  c = b.isHorizontal() ? 0 : r * d,
	                  m = -i * Math.abs(d),
	                  h = b.isHorizontal() ? 0 : b.params.coverflow.stretch * d,
	                  f = b.isHorizontal() ? b.params.coverflow.stretch * d : 0;Math.abs(f) < .001 && (f = 0), Math.abs(h) < .001 && (h = 0), Math.abs(m) < .001 && (m = 0), Math.abs(u) < .001 && (u = 0), Math.abs(c) < .001 && (c = 0);var g = "translate3d(" + f + "px," + h + "px," + m + "px)  rotateX(" + c + "deg) rotateY(" + u + "deg)";if (o.transform(g), o[0].style.zIndex = -Math.abs(Math.round(d)) + 1, b.params.coverflow.slideShadows) {
	                var v = b.isHorizontal() ? o.find(".swiper-slide-shadow-left") : o.find(".swiper-slide-shadow-top"),
	                    w = b.isHorizontal() ? o.find(".swiper-slide-shadow-right") : o.find(".swiper-slide-shadow-bottom");0 === v.length && (v = a('<div class="swiper-slide-shadow-' + (b.isHorizontal() ? "left" : "top") + '"></div>'), o.append(v)), 0 === w.length && (w = a('<div class="swiper-slide-shadow-' + (b.isHorizontal() ? "right" : "bottom") + '"></div>'), o.append(w)), v.length && (v[0].style.opacity = d > 0 ? d : 0), w.length && (w[0].style.opacity = -d > 0 ? -d : 0);
	              }
	            }if (b.browser.ie) {
	              var y = b.wrapper[0].style;y.perspectiveOrigin = t + "px 50%";
	            }
	          }, setTransition: function (e) {
	            b.slides.transition(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(e);
	          } } }, b.lazy = { initialImageLoaded: !1, loadImageInSlide: function (e, t) {
	          if ("undefined" != typeof e && ("undefined" == typeof t && (t = !0), 0 !== b.slides.length)) {
	            var r = b.slides.eq(e),
	                i = r.find(".swiper-lazy:not(.swiper-lazy-loaded):not(.swiper-lazy-loading)");!r.hasClass("swiper-lazy") || r.hasClass("swiper-lazy-loaded") || r.hasClass("swiper-lazy-loading") || (i = i.add(r[0])), 0 !== i.length && i.each(function () {
	              var e = a(this);e.addClass("swiper-lazy-loading");var i = e.attr("data-background"),
	                  s = e.attr("data-src"),
	                  n = e.attr("data-srcset");b.loadImage(e[0], s || i, n, !1, function () {
	                if (i ? (e.css("background-image", 'url("' + i + '")'), e.removeAttr("data-background")) : (n && (e.attr("srcset", n), e.removeAttr("data-srcset")), s && (e.attr("src", s), e.removeAttr("data-src"))), e.addClass("swiper-lazy-loaded").removeClass("swiper-lazy-loading"), r.find(".swiper-lazy-preloader, .preloader").remove(), b.params.loop && t) {
	                  var a = r.attr("data-swiper-slide-index");if (r.hasClass(b.params.slideDuplicateClass)) {
	                    var o = b.wrapper.children('[data-swiper-slide-index="' + a + '"]:not(.' + b.params.slideDuplicateClass + ")");b.lazy.loadImageInSlide(o.index(), !1);
	                  } else {
	                    var l = b.wrapper.children("." + b.params.slideDuplicateClass + '[data-swiper-slide-index="' + a + '"]');b.lazy.loadImageInSlide(l.index(), !1);
	                  }
	                }b.emit("onLazyImageReady", b, r[0], e[0]);
	              }), b.emit("onLazyImageLoad", b, r[0], e[0]);
	            });
	          }
	        }, load: function () {
	          var e;if (b.params.watchSlidesVisibility) b.wrapper.children("." + b.params.slideVisibleClass).each(function () {
	            b.lazy.loadImageInSlide(a(this).index());
	          });else if (b.params.slidesPerView > 1) for (e = b.activeIndex; e < b.activeIndex + b.params.slidesPerView; e++) b.slides[e] && b.lazy.loadImageInSlide(e);else b.lazy.loadImageInSlide(b.activeIndex);if (b.params.lazyLoadingInPrevNext) if (b.params.slidesPerView > 1 || b.params.lazyLoadingInPrevNextAmount && b.params.lazyLoadingInPrevNextAmount > 1) {
	            var t = b.params.lazyLoadingInPrevNextAmount,
	                r = b.params.slidesPerView,
	                i = Math.min(b.activeIndex + r + Math.max(t, r), b.slides.length),
	                s = Math.max(b.activeIndex - Math.max(r, t), 0);for (e = b.activeIndex + b.params.slidesPerView; i > e; e++) b.slides[e] && b.lazy.loadImageInSlide(e);for (e = s; e < b.activeIndex; e++) b.slides[e] && b.lazy.loadImageInSlide(e);
	          } else {
	            var n = b.wrapper.children("." + b.params.slideNextClass);n.length > 0 && b.lazy.loadImageInSlide(n.index());var o = b.wrapper.children("." + b.params.slidePrevClass);o.length > 0 && b.lazy.loadImageInSlide(o.index());
	          }
	        }, onTransitionStart: function () {
	          b.params.lazyLoading && (b.params.lazyLoadingOnTransitionStart || !b.params.lazyLoadingOnTransitionStart && !b.lazy.initialImageLoaded) && b.lazy.load();
	        }, onTransitionEnd: function () {
	          b.params.lazyLoading && !b.params.lazyLoadingOnTransitionStart && b.lazy.load();
	        } }, b.scrollbar = { isTouched: !1, setDragPosition: function (e) {
	          var a = b.scrollbar,
	              t = b.isHorizontal() ? "touchstart" === e.type || "touchmove" === e.type ? e.targetTouches[0].pageX : e.pageX || e.clientX : "touchstart" === e.type || "touchmove" === e.type ? e.targetTouches[0].pageY : e.pageY || e.clientY,
	              r = t - a.track.offset()[b.isHorizontal() ? "left" : "top"] - a.dragSize / 2,
	              i = -b.minTranslate() * a.moveDivider,
	              s = -b.maxTranslate() * a.moveDivider;i > r ? r = i : r > s && (r = s), r = -r / a.moveDivider, b.updateProgress(r), b.setWrapperTranslate(r, !0);
	        }, dragStart: function (e) {
	          var a = b.scrollbar;a.isTouched = !0, e.preventDefault(), e.stopPropagation(), a.setDragPosition(e), clearTimeout(a.dragTimeout), a.track.transition(0), b.params.scrollbarHide && a.track.css("opacity", 1), b.wrapper.transition(100), a.drag.transition(100), b.emit("onScrollbarDragStart", b);
	        }, dragMove: function (e) {
	          var a = b.scrollbar;a.isTouched && (e.preventDefault ? e.preventDefault() : e.returnValue = !1, a.setDragPosition(e), b.wrapper.transition(0), a.track.transition(0), a.drag.transition(0), b.emit("onScrollbarDragMove", b));
	        }, dragEnd: function (e) {
	          var a = b.scrollbar;a.isTouched && (a.isTouched = !1, b.params.scrollbarHide && (clearTimeout(a.dragTimeout), a.dragTimeout = setTimeout(function () {
	            a.track.css("opacity", 0), a.track.transition(400);
	          }, 1e3)), b.emit("onScrollbarDragEnd", b), b.params.scrollbarSnapOnRelease && b.slideReset());
	        }, enableDraggable: function () {
	          var e = b.scrollbar,
	              t = b.support.touch ? e.track : document;a(e.track).on(b.touchEvents.start, e.dragStart), a(t).on(b.touchEvents.move, e.dragMove), a(t).on(b.touchEvents.end, e.dragEnd);
	        }, disableDraggable: function () {
	          var e = b.scrollbar,
	              t = b.support.touch ? e.track : document;a(e.track).off(b.touchEvents.start, e.dragStart), a(t).off(b.touchEvents.move, e.dragMove), a(t).off(b.touchEvents.end, e.dragEnd);
	        }, set: function () {
	          if (b.params.scrollbar) {
	            var e = b.scrollbar;e.track = a(b.params.scrollbar), b.params.uniqueNavElements && "string" == typeof b.params.scrollbar && e.track.length > 1 && 1 === b.container.find(b.params.scrollbar).length && (e.track = b.container.find(b.params.scrollbar)), e.drag = e.track.find(".swiper-scrollbar-drag"), 0 === e.drag.length && (e.drag = a('<div class="swiper-scrollbar-drag"></div>'), e.track.append(e.drag)), e.drag[0].style.width = "", e.drag[0].style.height = "", e.trackSize = b.isHorizontal() ? e.track[0].offsetWidth : e.track[0].offsetHeight, e.divider = b.size / b.virtualSize, e.moveDivider = e.divider * (e.trackSize / b.size), e.dragSize = e.trackSize * e.divider, b.isHorizontal() ? e.drag[0].style.width = e.dragSize + "px" : e.drag[0].style.height = e.dragSize + "px", e.divider >= 1 ? e.track[0].style.display = "none" : e.track[0].style.display = "", b.params.scrollbarHide && (e.track[0].style.opacity = 0);
	          }
	        }, setTranslate: function () {
	          if (b.params.scrollbar) {
	            var e,
	                a = b.scrollbar,
	                t = (b.translate || 0, a.dragSize);e = (a.trackSize - a.dragSize) * b.progress, b.rtl && b.isHorizontal() ? (e = -e, e > 0 ? (t = a.dragSize - e, e = 0) : -e + a.dragSize > a.trackSize && (t = a.trackSize + e)) : 0 > e ? (t = a.dragSize + e, e = 0) : e + a.dragSize > a.trackSize && (t = a.trackSize - e), b.isHorizontal() ? (b.support.transforms3d ? a.drag.transform("translate3d(" + e + "px, 0, 0)") : a.drag.transform("translateX(" + e + "px)"), a.drag[0].style.width = t + "px") : (b.support.transforms3d ? a.drag.transform("translate3d(0px, " + e + "px, 0)") : a.drag.transform("translateY(" + e + "px)"), a.drag[0].style.height = t + "px"), b.params.scrollbarHide && (clearTimeout(a.timeout), a.track[0].style.opacity = 1, a.timeout = setTimeout(function () {
	              a.track[0].style.opacity = 0, a.track.transition(400);
	            }, 1e3));
	          }
	        }, setTransition: function (e) {
	          b.params.scrollbar && b.scrollbar.drag.transition(e);
	        } }, b.controller = { LinearSpline: function (e, a) {
	          this.x = e, this.y = a, this.lastIndex = e.length - 1;var t, r;this.x.length;this.interpolate = function (e) {
	            return e ? (r = i(this.x, e), t = r - 1, (e - this.x[t]) * (this.y[r] - this.y[t]) / (this.x[r] - this.x[t]) + this.y[t]) : 0;
	          };var i = function () {
	            var e, a, t;return function (r, i) {
	              for (a = -1, e = r.length; e - a > 1;) r[t = e + a >> 1] <= i ? a = t : e = t;return e;
	            };
	          }();
	        }, getInterpolateFunction: function (e) {
	          b.controller.spline || (b.controller.spline = b.params.loop ? new b.controller.LinearSpline(b.slidesGrid, e.slidesGrid) : new b.controller.LinearSpline(b.snapGrid, e.snapGrid));
	        }, setTranslate: function (e, a) {
	          function r(a) {
	            e = a.rtl && "horizontal" === a.params.direction ? -b.translate : b.translate, "slide" === b.params.controlBy && (b.controller.getInterpolateFunction(a), s = -b.controller.spline.interpolate(-e)), s && "container" !== b.params.controlBy || (i = (a.maxTranslate() - a.minTranslate()) / (b.maxTranslate() - b.minTranslate()), s = (e - b.minTranslate()) * i + a.minTranslate()), b.params.controlInverse && (s = a.maxTranslate() - s), a.updateProgress(s), a.setWrapperTranslate(s, !1, b), a.updateActiveIndex();
	          }var i,
	              s,
	              n = b.params.control;if (b.isArray(n)) for (var o = 0; o < n.length; o++) n[o] !== a && n[o] instanceof t && r(n[o]);else n instanceof t && a !== n && r(n);
	        }, setTransition: function (e, a) {
	          function r(a) {
	            a.setWrapperTransition(e, b), 0 !== e && (a.onTransitionStart(), a.wrapper.transitionEnd(function () {
	              s && (a.params.loop && "slide" === b.params.controlBy && a.fixLoop(), a.onTransitionEnd());
	            }));
	          }var i,
	              s = b.params.control;if (b.isArray(s)) for (i = 0; i < s.length; i++) s[i] !== a && s[i] instanceof t && r(s[i]);else s instanceof t && a !== s && r(s);
	        } }, b.hashnav = { init: function () {
	          if (b.params.hashnav) {
	            b.hashnav.initialized = !0;var e = document.location.hash.replace("#", "");if (e) for (var a = 0, t = 0, r = b.slides.length; r > t; t++) {
	              var i = b.slides.eq(t),
	                  s = i.attr("data-hash");if (s === e && !i.hasClass(b.params.slideDuplicateClass)) {
	                var n = i.index();b.slideTo(n, a, b.params.runCallbacksOnInit, !0);
	              }
	            }
	          }
	        }, setHash: function () {
	          b.hashnav.initialized && b.params.hashnav && (document.location.hash = b.slides.eq(b.activeIndex).attr("data-hash") || "");
	        } }, b.disableKeyboardControl = function () {
	        b.params.keyboardControl = !1, a(document).off("keydown", p);
	      }, b.enableKeyboardControl = function () {
	        b.params.keyboardControl = !0, a(document).on("keydown", p);
	      }, b.mousewheel = { event: !1, lastScrollTime: new window.Date().getTime() }, b.params.mousewheelControl) {
	        try {
	          new window.WheelEvent("wheel"), b.mousewheel.event = "wheel";
	        } catch (N) {
	          (window.WheelEvent || b.container[0] && "wheel" in b.container[0]) && (b.mousewheel.event = "wheel");
	        }!b.mousewheel.event && window.WheelEvent, b.mousewheel.event || void 0 === document.onmousewheel || (b.mousewheel.event = "mousewheel"), b.mousewheel.event || (b.mousewheel.event = "DOMMouseScroll");
	      }b.disableMousewheelControl = function () {
	        return b.mousewheel.event ? (b.container.off(b.mousewheel.event, d), !0) : !1;
	      }, b.enableMousewheelControl = function () {
	        return b.mousewheel.event ? (b.container.on(b.mousewheel.event, d), !0) : !1;
	      }, b.parallax = { setTranslate: function () {
	          b.container.children("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]").each(function () {
	            u(this, b.progress);
	          }), b.slides.each(function () {
	            var e = a(this);e.find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]").each(function () {
	              var a = Math.min(Math.max(e[0].progress, -1), 1);u(this, a);
	            });
	          });
	        }, setTransition: function (e) {
	          "undefined" == typeof e && (e = b.params.speed), b.container.find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]").each(function () {
	            var t = a(this),
	                r = parseInt(t.attr("data-swiper-parallax-duration"), 10) || e;0 === e && (r = 0), t.transition(r);
	          });
	        } }, b._plugins = [];for (var R in b.plugins) {
	        var W = b.plugins[R](b, b.params[R]);W && b._plugins.push(W);
	      }return b.callPlugins = function (e) {
	        for (var a = 0; a < b._plugins.length; a++) e in b._plugins[a] && b._plugins[a][e](arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
	      }, b.emitterEventListeners = {}, b.emit = function (e) {
	        b.params[e] && b.params[e](arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);var a;if (b.emitterEventListeners[e]) for (a = 0; a < b.emitterEventListeners[e].length; a++) b.emitterEventListeners[e][a](arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);b.callPlugins && b.callPlugins(e, arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
	      }, b.on = function (e, a) {
	        return e = c(e), b.emitterEventListeners[e] || (b.emitterEventListeners[e] = []), b.emitterEventListeners[e].push(a), b;
	      }, b.off = function (e, a) {
	        var t;if (e = c(e), "undefined" == typeof a) return b.emitterEventListeners[e] = [], b;if (b.emitterEventListeners[e] && 0 !== b.emitterEventListeners[e].length) {
	          for (t = 0; t < b.emitterEventListeners[e].length; t++) b.emitterEventListeners[e][t] === a && b.emitterEventListeners[e].splice(t, 1);return b;
	        }
	      }, b.once = function (e, a) {
	        e = c(e);var t = function () {
	          a(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4]), b.off(e, t);
	        };return b.on(e, t), b;
	      }, b.a11y = { makeFocusable: function (e) {
	          return e.attr("tabIndex", "0"), e;
	        }, addRole: function (e, a) {
	          return e.attr("role", a), e;
	        }, addLabel: function (e, a) {
	          return e.attr("aria-label", a), e;
	        }, disable: function (e) {
	          return e.attr("aria-disabled", !0), e;
	        }, enable: function (e) {
	          return e.attr("aria-disabled", !1), e;
	        }, onEnterKey: function (e) {
	          13 === e.keyCode && (a(e.target).is(b.params.nextButton) ? (b.onClickNext(e), b.isEnd ? b.a11y.notify(b.params.lastSlideMessage) : b.a11y.notify(b.params.nextSlideMessage)) : a(e.target).is(b.params.prevButton) && (b.onClickPrev(e), b.isBeginning ? b.a11y.notify(b.params.firstSlideMessage) : b.a11y.notify(b.params.prevSlideMessage)), a(e.target).is("." + b.params.bulletClass) && a(e.target)[0].click());
	        }, liveRegion: a('<span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>'), notify: function (e) {
	          var a = b.a11y.liveRegion;0 !== a.length && (a.html(""), a.html(e));
	        }, init: function () {
	          b.params.nextButton && b.nextButton && b.nextButton.length > 0 && (b.a11y.makeFocusable(b.nextButton), b.a11y.addRole(b.nextButton, "button"), b.a11y.addLabel(b.nextButton, b.params.nextSlideMessage)), b.params.prevButton && b.prevButton && b.prevButton.length > 0 && (b.a11y.makeFocusable(b.prevButton), b.a11y.addRole(b.prevButton, "button"), b.a11y.addLabel(b.prevButton, b.params.prevSlideMessage)), a(b.container).append(b.a11y.liveRegion);
	        }, initPagination: function () {
	          b.params.pagination && b.params.paginationClickable && b.bullets && b.bullets.length && b.bullets.each(function () {
	            var e = a(this);b.a11y.makeFocusable(e), b.a11y.addRole(e, "button"), b.a11y.addLabel(e, b.params.paginationBulletMessage.replace(/{{index}}/, e.index() + 1));
	          });
	        }, destroy: function () {
	          b.a11y.liveRegion && b.a11y.liveRegion.length > 0 && b.a11y.liveRegion.remove();
	        } }, b.init = function () {
	        b.params.loop && b.createLoop(), b.updateContainerSize(), b.updateSlidesSize(), b.updatePagination(), b.params.scrollbar && b.scrollbar && (b.scrollbar.set(), b.params.scrollbarDraggable && b.scrollbar.enableDraggable()), "slide" !== b.params.effect && b.effects[b.params.effect] && (b.params.loop || b.updateProgress(), b.effects[b.params.effect].setTranslate()), b.params.loop ? b.slideTo(b.params.initialSlide + b.loopedSlides, 0, b.params.runCallbacksOnInit) : (b.slideTo(b.params.initialSlide, 0, b.params.runCallbacksOnInit), 0 === b.params.initialSlide && (b.parallax && b.params.parallax && b.parallax.setTranslate(), b.lazy && b.params.lazyLoading && (b.lazy.load(), b.lazy.initialImageLoaded = !0))), b.attachEvents(), b.params.observer && b.support.observer && b.initObservers(), b.params.preloadImages && !b.params.lazyLoading && b.preloadImages(), b.params.autoplay && b.startAutoplay(), b.params.keyboardControl && b.enableKeyboardControl && b.enableKeyboardControl(), b.params.mousewheelControl && b.enableMousewheelControl && b.enableMousewheelControl(), b.params.hashnav && b.hashnav && b.hashnav.init(), b.params.a11y && b.a11y && b.a11y.init(), b.emit("onInit", b);
	      }, b.cleanupStyles = function () {
	        b.container.removeClass(b.classNames.join(" ")).removeAttr("style"), b.wrapper.removeAttr("style"), b.slides && b.slides.length && b.slides.removeClass([b.params.slideVisibleClass, b.params.slideActiveClass, b.params.slideNextClass, b.params.slidePrevClass].join(" ")).removeAttr("style").removeAttr("data-swiper-column").removeAttr("data-swiper-row"), b.paginationContainer && b.paginationContainer.length && b.paginationContainer.removeClass(b.params.paginationHiddenClass), b.bullets && b.bullets.length && b.bullets.removeClass(b.params.bulletActiveClass), b.params.prevButton && a(b.params.prevButton).removeClass(b.params.buttonDisabledClass), b.params.nextButton && a(b.params.nextButton).removeClass(b.params.buttonDisabledClass), b.params.scrollbar && b.scrollbar && (b.scrollbar.track && b.scrollbar.track.length && b.scrollbar.track.removeAttr("style"), b.scrollbar.drag && b.scrollbar.drag.length && b.scrollbar.drag.removeAttr("style"));
	      }, b.destroy = function (e, a) {
	        b.detachEvents(), b.stopAutoplay(), b.params.scrollbar && b.scrollbar && b.params.scrollbarDraggable && b.scrollbar.disableDraggable(), b.params.loop && b.destroyLoop(), a && b.cleanupStyles(), b.disconnectObservers(), b.params.keyboardControl && b.disableKeyboardControl && b.disableKeyboardControl(), b.params.mousewheelControl && b.disableMousewheelControl && b.disableMousewheelControl(), b.params.a11y && b.a11y && b.a11y.destroy(), b.emit("onDestroy"), e !== !1 && (b = null);
	      }, b.init(), b;
	    }
	  };t.prototype = { isSafari: function () {
	      var e = navigator.userAgent.toLowerCase();return e.indexOf("safari") >= 0 && e.indexOf("chrome") < 0 && e.indexOf("android") < 0;
	    }(), isUiWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(navigator.userAgent), isArray: function (e) {
	      return "[object Array]" === Object.prototype.toString.apply(e);
	    }, browser: { ie: window.navigator.pointerEnabled || window.navigator.msPointerEnabled, ieTouch: window.navigator.msPointerEnabled && window.navigator.msMaxTouchPoints > 1 || window.navigator.pointerEnabled && window.navigator.maxTouchPoints > 1 }, device: function () {
	      var e = navigator.userAgent,
	          a = e.match(/(Android);?[\s\/]+([\d.]+)?/),
	          t = e.match(/(iPad).*OS\s([\d_]+)/),
	          r = e.match(/(iPod)(.*OS\s([\d_]+))?/),
	          i = !t && e.match(/(iPhone\sOS)\s([\d_]+)/);return { ios: t || i || r, android: a };
	    }(), support: { touch: window.Modernizr && Modernizr.touch === !0 || function () {
	        return !!("ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch);
	      }(), transforms3d: window.Modernizr && Modernizr.csstransforms3d === !0 || function () {
	        var e = document.createElement("div").style;return "webkitPerspective" in e || "MozPerspective" in e || "OPerspective" in e || "MsPerspective" in e || "perspective" in e;
	      }(), flexbox: function () {
	        for (var e = document.createElement("div").style, a = "alignItems webkitAlignItems webkitBoxAlign msFlexAlign mozBoxAlign webkitFlexDirection msFlexDirection mozBoxDirection mozBoxOrient webkitBoxDirection webkitBoxOrient".split(" "), t = 0; t < a.length; t++) if (a[t] in e) return !0;
	      }(), observer: function () {
	        return "MutationObserver" in window || "WebkitMutationObserver" in window;
	      }() }, plugins: {} };for (var r = function () {
	    var e = function (e) {
	      var a = this,
	          t = 0;for (t = 0; t < e.length; t++) a[t] = e[t];return a.length = e.length, this;
	    },
	        a = function (a, t) {
	      var r = [],
	          i = 0;if (a && !t && a instanceof e) return a;if (a) if ("string" == typeof a) {
	        var s,
	            n,
	            o = a.trim();if (o.indexOf("<") >= 0 && o.indexOf(">") >= 0) {
	          var l = "div";for (0 === o.indexOf("<li") && (l = "ul"), 0 === o.indexOf("<tr") && (l = "tbody"), (0 === o.indexOf("<td") || 0 === o.indexOf("<th")) && (l = "tr"), 0 === o.indexOf("<tbody") && (l = "table"), 0 === o.indexOf("<option") && (l = "select"), n = document.createElement(l), n.innerHTML = a, i = 0; i < n.childNodes.length; i++) r.push(n.childNodes[i]);
	        } else for (s = t || "#" !== a[0] || a.match(/[ .<>:~]/) ? (t || document).querySelectorAll(a) : [document.getElementById(a.split("#")[1])], i = 0; i < s.length; i++) s[i] && r.push(s[i]);
	      } else if (a.nodeType || a === window || a === document) r.push(a);else if (a.length > 0 && a[0].nodeType) for (i = 0; i < a.length; i++) r.push(a[i]);return new e(r);
	    };return e.prototype = { addClass: function (e) {
	        if ("undefined" == typeof e) return this;for (var a = e.split(" "), t = 0; t < a.length; t++) for (var r = 0; r < this.length; r++) this[r].classList.add(a[t]);return this;
	      }, removeClass: function (e) {
	        for (var a = e.split(" "), t = 0; t < a.length; t++) for (var r = 0; r < this.length; r++) this[r].classList.remove(a[t]);return this;
	      }, hasClass: function (e) {
	        return this[0] ? this[0].classList.contains(e) : !1;
	      }, toggleClass: function (e) {
	        for (var a = e.split(" "), t = 0; t < a.length; t++) for (var r = 0; r < this.length; r++) this[r].classList.toggle(a[t]);return this;
	      }, attr: function (e, a) {
	        if (1 === arguments.length && "string" == typeof e) return this[0] ? this[0].getAttribute(e) : void 0;for (var t = 0; t < this.length; t++) if (2 === arguments.length) this[t].setAttribute(e, a);else for (var r in e) this[t][r] = e[r], this[t].setAttribute(r, e[r]);return this;
	      }, removeAttr: function (e) {
	        for (var a = 0; a < this.length; a++) this[a].removeAttribute(e);return this;
	      }, data: function (e, a) {
	        if ("undefined" != typeof a) {
	          for (var t = 0; t < this.length; t++) {
	            var r = this[t];r.dom7ElementDataStorage || (r.dom7ElementDataStorage = {}), r.dom7ElementDataStorage[e] = a;
	          }return this;
	        }if (this[0]) {
	          var i = this[0].getAttribute("data-" + e);return i ? i : this[0].dom7ElementDataStorage && (e in this[0].dom7ElementDataStorage) ? this[0].dom7ElementDataStorage[e] : void 0;
	        }
	      }, transform: function (e) {
	        for (var a = 0; a < this.length; a++) {
	          var t = this[a].style;t.webkitTransform = t.MsTransform = t.msTransform = t.MozTransform = t.OTransform = t.transform = e;
	        }return this;
	      }, transition: function (e) {
	        "string" != typeof e && (e += "ms");for (var a = 0; a < this.length; a++) {
	          var t = this[a].style;t.webkitTransitionDuration = t.MsTransitionDuration = t.msTransitionDuration = t.MozTransitionDuration = t.OTransitionDuration = t.transitionDuration = e;
	        }return this;
	      }, on: function (e, t, r, i) {
	        function s(e) {
	          var i = e.target;if (a(i).is(t)) r.call(i, e);else for (var s = a(i).parents(), n = 0; n < s.length; n++) a(s[n]).is(t) && r.call(s[n], e);
	        }var n,
	            o,
	            l = e.split(" ");for (n = 0; n < this.length; n++) if ("function" == typeof t || t === !1) for ("function" == typeof t && (r = arguments[1], i = arguments[2] || !1), o = 0; o < l.length; o++) this[n].addEventListener(l[o], r, i);else for (o = 0; o < l.length; o++) this[n].dom7LiveListeners || (this[n].dom7LiveListeners = []), this[n].dom7LiveListeners.push({ listener: r, liveListener: s }), this[n].addEventListener(l[o], s, i);return this;
	      }, off: function (e, a, t, r) {
	        for (var i = e.split(" "), s = 0; s < i.length; s++) for (var n = 0; n < this.length; n++) if ("function" == typeof a || a === !1) "function" == typeof a && (t = arguments[1], r = arguments[2] || !1), this[n].removeEventListener(i[s], t, r);else if (this[n].dom7LiveListeners) for (var o = 0; o < this[n].dom7LiveListeners.length; o++) this[n].dom7LiveListeners[o].listener === t && this[n].removeEventListener(i[s], this[n].dom7LiveListeners[o].liveListener, r);return this;
	      }, once: function (e, a, t, r) {
	        function i(n) {
	          t(n), s.off(e, a, i, r);
	        }var s = this;"function" == typeof a && (a = !1, t = arguments[1], r = arguments[2]), s.on(e, a, i, r);
	      }, trigger: function (e, a) {
	        for (var t = 0; t < this.length; t++) {
	          var r;try {
	            r = new window.CustomEvent(e, { detail: a, bubbles: !0, cancelable: !0 });
	          } catch (i) {
	            r = document.createEvent("Event"), r.initEvent(e, !0, !0), r.detail = a;
	          }this[t].dispatchEvent(r);
	        }return this;
	      }, transitionEnd: function (e) {
	        function a(s) {
	          if (s.target === this) for (e.call(this, s), t = 0; t < r.length; t++) i.off(r[t], a);
	        }var t,
	            r = ["webkitTransitionEnd", "transitionend", "oTransitionEnd", "MSTransitionEnd", "msTransitionEnd"],
	            i = this;if (e) for (t = 0; t < r.length; t++) i.on(r[t], a);return this;
	      }, width: function () {
	        return this[0] === window ? window.innerWidth : this.length > 0 ? parseFloat(this.css("width")) : null;
	      }, outerWidth: function (e) {
	        return this.length > 0 ? e ? this[0].offsetWidth + parseFloat(this.css("margin-right")) + parseFloat(this.css("margin-left")) : this[0].offsetWidth : null;
	      }, height: function () {
	        return this[0] === window ? window.innerHeight : this.length > 0 ? parseFloat(this.css("height")) : null;
	      }, outerHeight: function (e) {
	        return this.length > 0 ? e ? this[0].offsetHeight + parseFloat(this.css("margin-top")) + parseFloat(this.css("margin-bottom")) : this[0].offsetHeight : null;
	      }, offset: function () {
	        if (this.length > 0) {
	          var e = this[0],
	              a = e.getBoundingClientRect(),
	              t = document.body,
	              r = e.clientTop || t.clientTop || 0,
	              i = e.clientLeft || t.clientLeft || 0,
	              s = window.pageYOffset || e.scrollTop,
	              n = window.pageXOffset || e.scrollLeft;return { top: a.top + s - r, left: a.left + n - i };
	        }return null;
	      }, css: function (e, a) {
	        var t;if (1 === arguments.length) {
	          if ("string" != typeof e) {
	            for (t = 0; t < this.length; t++) for (var r in e) this[t].style[r] = e[r];return this;
	          }if (this[0]) return window.getComputedStyle(this[0], null).getPropertyValue(e);
	        }if (2 === arguments.length && "string" == typeof e) {
	          for (t = 0; t < this.length; t++) this[t].style[e] = a;return this;
	        }return this;
	      }, each: function (e) {
	        for (var a = 0; a < this.length; a++) e.call(this[a], a, this[a]);return this;
	      }, html: function (e) {
	        if ("undefined" == typeof e) return this[0] ? this[0].innerHTML : void 0;for (var a = 0; a < this.length; a++) this[a].innerHTML = e;return this;
	      }, text: function (e) {
	        if ("undefined" == typeof e) return this[0] ? this[0].textContent.trim() : null;for (var a = 0; a < this.length; a++) this[a].textContent = e;return this;
	      }, is: function (t) {
	        if (!this[0]) return !1;var r, i;if ("string" == typeof t) {
	          var s = this[0];if (s === document) return t === document;if (s === window) return t === window;if (s.matches) return s.matches(t);if (s.webkitMatchesSelector) return s.webkitMatchesSelector(t);if (s.mozMatchesSelector) return s.mozMatchesSelector(t);if (s.msMatchesSelector) return s.msMatchesSelector(t);for (r = a(t), i = 0; i < r.length; i++) if (r[i] === this[0]) return !0;return !1;
	        }if (t === document) return this[0] === document;if (t === window) return this[0] === window;if (t.nodeType || t instanceof e) {
	          for (r = t.nodeType ? [t] : t, i = 0; i < r.length; i++) if (r[i] === this[0]) return !0;return !1;
	        }return !1;
	      }, index: function () {
	        if (this[0]) {
	          for (var e = this[0], a = 0; null !== (e = e.previousSibling);) 1 === e.nodeType && a++;return a;
	        }
	      }, eq: function (a) {
	        if ("undefined" == typeof a) return this;var t,
	            r = this.length;return a > r - 1 ? new e([]) : 0 > a ? (t = r + a, new e(0 > t ? [] : [this[t]])) : new e([this[a]]);
	      }, append: function (a) {
	        var t, r;for (t = 0; t < this.length; t++) if ("string" == typeof a) {
	          var i = document.createElement("div");for (i.innerHTML = a; i.firstChild;) this[t].appendChild(i.firstChild);
	        } else if (a instanceof e) for (r = 0; r < a.length; r++) this[t].appendChild(a[r]);else this[t].appendChild(a);return this;
	      }, prepend: function (a) {
	        var t, r;for (t = 0; t < this.length; t++) if ("string" == typeof a) {
	          var i = document.createElement("div");for (i.innerHTML = a, r = i.childNodes.length - 1; r >= 0; r--) this[t].insertBefore(i.childNodes[r], this[t].childNodes[0]);
	        } else if (a instanceof e) for (r = 0; r < a.length; r++) this[t].insertBefore(a[r], this[t].childNodes[0]);else this[t].insertBefore(a, this[t].childNodes[0]);return this;
	      }, insertBefore: function (e) {
	        for (var t = a(e), r = 0; r < this.length; r++) if (1 === t.length) t[0].parentNode.insertBefore(this[r], t[0]);else if (t.length > 1) for (var i = 0; i < t.length; i++) t[i].parentNode.insertBefore(this[r].cloneNode(!0), t[i]);
	      }, insertAfter: function (e) {
	        for (var t = a(e), r = 0; r < this.length; r++) if (1 === t.length) t[0].parentNode.insertBefore(this[r], t[0].nextSibling);else if (t.length > 1) for (var i = 0; i < t.length; i++) t[i].parentNode.insertBefore(this[r].cloneNode(!0), t[i].nextSibling);
	      }, next: function (t) {
	        return new e(this.length > 0 ? t ? this[0].nextElementSibling && a(this[0].nextElementSibling).is(t) ? [this[0].nextElementSibling] : [] : this[0].nextElementSibling ? [this[0].nextElementSibling] : [] : []);
	      }, nextAll: function (t) {
	        var r = [],
	            i = this[0];if (!i) return new e([]);for (; i.nextElementSibling;) {
	          var s = i.nextElementSibling;t ? a(s).is(t) && r.push(s) : r.push(s), i = s;
	        }return new e(r);
	      }, prev: function (t) {
	        return new e(this.length > 0 ? t ? this[0].previousElementSibling && a(this[0].previousElementSibling).is(t) ? [this[0].previousElementSibling] : [] : this[0].previousElementSibling ? [this[0].previousElementSibling] : [] : []);
	      }, prevAll: function (t) {
	        var r = [],
	            i = this[0];if (!i) return new e([]);for (; i.previousElementSibling;) {
	          var s = i.previousElementSibling;t ? a(s).is(t) && r.push(s) : r.push(s), i = s;
	        }return new e(r);
	      }, parent: function (e) {
	        for (var t = [], r = 0; r < this.length; r++) e ? a(this[r].parentNode).is(e) && t.push(this[r].parentNode) : t.push(this[r].parentNode);return a(a.unique(t));
	      }, parents: function (e) {
	        for (var t = [], r = 0; r < this.length; r++) for (var i = this[r].parentNode; i;) e ? a(i).is(e) && t.push(i) : t.push(i), i = i.parentNode;return a(a.unique(t));
	      }, find: function (a) {
	        for (var t = [], r = 0; r < this.length; r++) for (var i = this[r].querySelectorAll(a), s = 0; s < i.length; s++) t.push(i[s]);return new e(t);
	      }, children: function (t) {
	        for (var r = [], i = 0; i < this.length; i++) for (var s = this[i].childNodes, n = 0; n < s.length; n++) t ? 1 === s[n].nodeType && a(s[n]).is(t) && r.push(s[n]) : 1 === s[n].nodeType && r.push(s[n]);return new e(a.unique(r));
	      }, remove: function () {
	        for (var e = 0; e < this.length; e++) this[e].parentNode && this[e].parentNode.removeChild(this[e]);return this;
	      }, add: function () {
	        var e,
	            t,
	            r = this;for (e = 0; e < arguments.length; e++) {
	          var i = a(arguments[e]);for (t = 0; t < i.length; t++) r[r.length] = i[t], r.length++;
	        }return r;
	      } }, a.fn = e.prototype, a.unique = function (e) {
	      for (var a = [], t = 0; t < e.length; t++) -1 === a.indexOf(e[t]) && a.push(e[t]);return a;
	    }, a;
	  }(), i = ["jQuery", "Zepto", "Dom7"], s = 0; s < i.length; s++) window[i[s]] && e(window[i[s]]);var n;n = "undefined" == typeof r ? window.Dom7 || window.Zepto || window.jQuery : r, n && ("transitionEnd" in n.fn || (n.fn.transitionEnd = function (e) {
	    function a(s) {
	      if (s.target === this) for (e.call(this, s), t = 0; t < r.length; t++) i.off(r[t], a);
	    }var t,
	        r = ["webkitTransitionEnd", "transitionend", "oTransitionEnd", "MSTransitionEnd", "msTransitionEnd"],
	        i = this;if (e) for (t = 0; t < r.length; t++) i.on(r[t], a);return this;
	  }), "transform" in n.fn || (n.fn.transform = function (e) {
	    for (var a = 0; a < this.length; a++) {
	      var t = this[a].style;t.webkitTransform = t.MsTransform = t.msTransform = t.MozTransform = t.OTransform = t.transform = e;
	    }return this;
	  }), "transition" in n.fn || (n.fn.transition = function (e) {
	    "string" != typeof e && (e += "ms");for (var a = 0; a < this.length; a++) {
	      var t = this[a].style;t.webkitTransitionDuration = t.MsTransitionDuration = t.msTransitionDuration = t.MozTransitionDuration = t.OTransitionDuration = t.transitionDuration = e;
	    }return this;
	  })), window.Swiper = t;
	}(),  true ? module.exports = window.Swiper : "function" == typeof define && define.amd && define([], function () {
	  "use strict";
	  return window.Swiper;
	});
	//# sourceMappingURL=maps/swiper.min.js.map

/***/ }
/******/ ]);


// WEBPACK FOOTER //
// js/index.js